export const RequiredIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#27591C" />
    <path
      d="M17.3332 8L9.99984 15.3333L6.6665 12"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*Empty State Icons*/
export const NoProductsvg = (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" rx="100" fill="#F0F2FA" />
    <path
      d="M181.54 159.08C183.495 159.08 185.08 157.495 185.08 155.54C185.08 153.585 183.495 152 181.54 152C179.585 152 178 153.585 178 155.54C178 157.495 179.585 159.08 181.54 159.08Z"
      fill="white"
    />
    <path
      d="M180.035 22.0526C181.774 22.0526 183.185 20.6423 183.185 18.9026C183.185 17.1629 181.774 15.7526 180.035 15.7526C178.295 15.7526 176.885 17.1629 176.885 18.9026C176.885 20.6423 178.295 22.0526 180.035 22.0526Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 35.7526C171.751 35.7526 174.885 32.6186 174.885 28.7526C174.885 24.8866 171.751 21.7526 167.885 21.7526C164.019 21.7526 160.885 24.8866 160.885 28.7526C160.885 32.6186 164.019 35.7526 167.885 35.7526Z"
      fill="white"
    />
    <path
      d="M37.8848 185.753C41.7507 185.753 44.8848 182.619 44.8848 178.753C44.8848 174.887 41.7507 171.753 37.8848 171.753C34.0188 171.753 30.8848 174.887 30.8848 178.753C30.8848 182.619 34.0188 185.753 37.8848 185.753Z"
      fill="white"
    />
    <path
      d="M191.885 157C192.989 157 193.885 156.105 193.885 155C193.885 153.895 192.989 153 191.885 153C190.78 153 189.885 153.895 189.885 155C189.885 156.105 190.78 157 191.885 157Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.301C38.3573 30.301 40.6633 27.995 40.6633 25.1505C40.6633 22.306 38.3573 20 35.5128 20C32.6683 20 30.3623 22.306 30.3623 25.1505C30.3623 27.995 32.6683 30.301 35.5128 30.301Z"
      fill="white"
    />
    <path
      d="M19.0123 30.3C20.4759 30.3 21.6623 29.1136 21.6623 27.65C21.6623 26.1864 20.4759 25 19.0123 25C17.5487 25 16.3623 26.1864 16.3623 27.65C16.3623 29.1136 17.5487 30.3 19.0123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195C36.0475 195 37.3906 193.657 37.3906 192C37.3906 190.343 36.0475 189 34.3906 189C32.7338 189 31.3906 190.343 31.3906 192C31.3906 193.657 32.7338 195 34.3906 195Z"
      fill="#C5B8EA"
    />
    <g filter="url(#filter0_i_1711_45594)">
      <path
        d="M157.896 170.553H38.2767C31.3514 170.553 26 165.784 26 160.219V38.3338C26 32.5045 31.6662 28 38.2767 28H157.896C164.822 28 170.173 32.7694 170.173 38.3338V160.219C170.173 165.784 164.507 170.553 157.896 170.553Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_i_1711_45594)">
      <circle cx="164" cy="164" r="20" fill="#D92D20" />
    </g>
    <path
      d="M161.147 152.573H166.772L165.272 168.199H162.647L161.147 152.573Z"
      fill="white"
    />
    <ellipse cx="163.96" cy="173.199" rx="2.8127" ry="2.50018" fill="white" />
    <g filter="url(#filter2_i_1711_45594)">
      <path
        d="M154.285 111.004C153.903 110.242 154.666 107.855 154.285 107.094C152.76 104.808 150.275 104.326 146.463 103.183C141.126 101.66 137.778 99.3654 133.585 98.9845C132.441 98.9845 131.297 98.6036 130.535 98.6036C118.717 97.461 108.806 95.5566 87.077 68.8956C84.7898 66.2295 83.6461 63.5634 81.3589 60.8973C79.0716 58.612 75.2595 61.2781 70.3038 62.4208C69.1601 62.8016 68.3977 62.8016 67.2541 62.8016C63.442 62.8016 58.8675 62.4208 54.6741 62.0399C48.956 61.2781 52.3869 58.2312 45.5251 102.031C45.1439 105.459 44.7627 108.506 44.3815 111.934C44.0002 114.6 44.0002 117.647 44.0002 120.313C44.0002 121.456 44.3815 123.36 45.5251 123.36C63.8232 125.265 75.6407 124.503 104.613 124.122C119.099 124.122 133.585 124.122 148.071 121.456L151.502 121.075C154.551 120.694 157.601 119.552 157.601 117.647C157.601 114.981 155.047 113.67 154.285 111.004Z"
        fill="#A9A6E2"
      />
    </g>
    <g filter="url(#filter3_i_1711_45594)">
      <path
        d="M133.583 99.3657L130.152 109.268C111.473 108.507 92.4122 96.6996 82.5007 81.4647C79.0698 76.1325 76.4014 70.4194 72.5893 65.849C72.5893 65.849 71.4456 64.3255 69.9208 63.1828C74.8765 62.0402 78.6886 59.3741 80.9759 61.6594C82.8819 63.5637 83.6444 65.0872 85.1692 66.9916C85.5504 67.7533 85.9316 68.1342 86.3128 68.8959C86.3128 69.2768 86.694 69.2768 86.694 69.6577C87.8377 71.1812 89.3625 72.7047 90.5061 74.2281C90.8873 74.609 91.2686 74.9899 91.6498 75.7516C93.1746 77.2751 94.3182 78.7986 95.8431 80.3221C96.2243 80.703 96.6055 81.0838 96.9867 81.8456C98.5116 83.3691 99.6552 84.8926 101.18 86.0352C101.561 86.4161 102.324 86.7969 102.705 87.5587C104.23 88.7013 105.373 89.8439 106.517 90.9865C107.279 91.3674 107.661 91.7483 108.423 92.51C109.567 93.2718 110.329 94.0335 111.473 94.4144C112.235 94.7952 112.998 95.1761 113.379 95.557C115.285 96.6996 117.191 97.4614 119.097 98.2231C119.859 98.604 120.622 98.604 121.384 98.9848C124.434 99.7466 127.102 100.127 130.152 100.508C131.296 98.9848 132.439 98.9848 133.583 99.3657Z"
        fill="url(#paint0_linear_1711_45594)"
      />
    </g>
    <g filter="url(#filter4_i_1711_45594)">
      <path
        d="M157.601 118.028C157.601 119.933 154.17 121.075 151.501 121.456L148.07 121.837C133.966 124.503 119.098 124.503 104.612 124.503C75.6405 124.503 64.2042 125.265 45.5248 123.741C44 123.741 44 121.837 44 120.694C44 117.647 44 114.981 44.3812 112.315C54.6739 113.077 98.1319 115.362 131.297 111.934C140.446 110.792 148.833 109.649 155.313 107.745C155.695 108.507 156.076 109.268 156.457 110.03C157.22 112.315 157.601 114.981 157.601 118.028Z"
        fill="url(#paint1_linear_1711_45594)"
      />
    </g>
    <g filter="url(#filter5_i_1711_45594)">
      <path
        d="M156.458 109.65C149.596 111.936 142.734 113.459 135.491 113.84C134.348 113.84 133.204 113.84 132.442 113.459C131.298 113.078 131.298 112.317 130.917 111.555C130.917 111.174 130.917 110.793 130.917 110.412C130.536 106.603 130.155 102.414 130.155 98.6052C135.11 98.986 140.447 99.3669 146.928 101.652C150.74 102.795 153.408 104.699 154.933 107.365C155.696 108.127 156.077 108.889 156.458 109.65Z"
        fill="#F0EDFA"
      />
    </g>
    <path
      d="M86.3162 68.5158C86.3162 68.8967 86.3162 68.8967 86.3162 68.5158L81.3604 72.3245C80.9792 72.3245 80.9792 72.7054 80.598 72.7054C80.2168 72.7054 79.8356 72.7054 79.8356 72.3245C79.4544 71.9437 79.4544 71.1819 80.2168 70.801L85.1726 66.9923H85.5538C85.5538 67.3732 85.935 68.1349 86.3162 68.5158Z"
      fill="#F0EDFA"
    />
    <path
      d="M92.0315 74.9885C92.0315 75.3694 92.0315 75.3694 91.6503 75.7503C90.1254 77.2738 88.6006 78.7973 86.6946 80.3208C86.3133 80.3208 86.3133 80.7016 85.9321 80.7016C85.5509 80.7016 85.1697 80.7016 85.1697 80.3208C84.7885 79.9399 84.7885 79.1781 85.5509 78.7973C87.0758 77.6547 88.6006 76.1312 90.1255 74.6077C90.5067 74.2268 90.5067 74.2268 90.8879 74.2268C90.8879 74.2268 91.6503 74.6077 92.0315 74.9885Z"
      fill="#F0EDFA"
    />
    <path
      d="M96.9886 81.0832C96.9886 81.4641 96.9886 81.4641 96.6074 81.845C95.0826 83.3685 93.1765 85.2728 91.6517 86.7963C91.2705 87.1772 91.2705 87.1772 90.8893 87.1772C90.5081 87.1772 90.1269 87.1772 90.1269 86.7963C89.7456 86.4154 89.7456 85.6537 90.1269 85.2728C91.6517 83.7493 93.5577 81.845 95.0826 80.3215C95.4638 79.9406 95.4638 79.9406 95.845 79.9406C96.2262 79.9406 96.6074 80.7024 96.9886 81.0832Z"
      fill="#F0EDFA"
    />
    <path
      d="M102.704 86.417C102.704 86.7979 102.704 86.7979 102.323 87.1788C100.417 88.7023 98.5112 90.6066 97.3675 92.511C96.9863 92.8919 96.9863 92.8919 96.6051 92.8919C96.2239 92.8919 96.2239 92.8919 95.8427 92.511C95.4615 92.1301 95.0803 91.3684 95.4615 90.9875C96.9863 89.0832 98.8924 87.1788 100.798 85.2744C100.798 85.2744 101.18 85.2744 101.18 84.8936C101.942 85.6553 102.323 86.0362 102.704 86.417Z"
      fill="#F0EDFA"
    />
    <path
      d="M108.423 90.9875C108.423 90.9875 108.423 91.3684 108.423 90.9875C107.279 93.2728 106.135 95.558 104.61 97.8432C104.229 98.2241 103.848 98.605 103.467 98.605H103.086C102.704 98.2241 102.323 97.4623 102.704 97.0815C103.848 94.7962 104.992 92.511 106.135 90.6066L106.517 90.2258C107.279 90.2258 107.66 90.6066 108.423 90.9875Z"
      fill="#F0EDFA"
    />
    <path
      d="M113.379 94.4148L112.236 101.27C112.236 102.032 111.473 102.413 111.092 102.413C110.33 102.413 109.948 101.651 109.948 100.89L111.092 93.2722C111.092 92.8913 111.092 92.8913 111.473 92.8913C112.236 93.653 112.617 94.0339 113.379 94.4148Z"
      fill="#F0EDFA"
    />
    <path
      d="M121.383 97.4615C121.002 99.3659 120.621 101.651 120.239 103.555C120.239 103.936 119.477 104.317 119.096 104.317C119.096 104.317 119.096 104.317 118.715 104.317C117.952 104.317 117.571 103.555 117.952 102.794C118.333 100.889 118.715 98.6041 119.096 96.6998C119.096 96.6998 119.096 96.6998 119.096 96.3189C119.858 97.0807 120.621 97.4615 121.383 97.4615Z"
      fill="#F0EDFA"
    />
    <g filter="url(#filter6_i_1711_45594)">
      <path
        d="M64.5858 91.3681C69.8492 91.3681 74.1161 87.1051 74.1161 81.8463C74.1161 76.5876 69.8492 72.3245 64.5858 72.3245C59.3224 72.3245 55.0555 76.5876 55.0555 81.8463C55.0555 87.1051 59.3224 91.3681 64.5858 91.3681Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter7_i_1711_45594)">
      <path
        d="M64.5835 85.6541C66.6888 85.6541 68.3956 83.9488 68.3956 81.8453C68.3956 79.7418 66.6888 78.0366 64.5835 78.0366C62.4781 78.0366 60.7714 79.7418 60.7714 81.8453C60.7714 83.9488 62.4781 85.6541 64.5835 85.6541Z"
        fill="#F0EDFA"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1711_45594"
        x="26"
        y="23.7864"
        width="144.173"
        height="146.767"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4.21361" />
        <feGaussianBlur stdDeviation="7.49086" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter1_i_1711_45594"
        x="144"
        y="139"
        width="45"
        height="45"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.596078 0 0 0 0 0.121569 0 0 0 0 0.0862745 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter2_i_1711_45594"
        x="44.0002"
        y="51"
        width="122.601"
        height="73.5981"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="16" dy="-20" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter3_i_1711_45594"
        x="69.9208"
        y="56.7621"
        width="66.6621"
        height="52.5063"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-5" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter4_i_1711_45594"
        x="44"
        y="107.745"
        width="116.601"
        height="19.9488"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter5_i_1711_45594"
        x="128.155"
        y="98.6052"
        width="28.3035"
        height="20.2349"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="5" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter6_i_1711_45594"
        x="55.0555"
        y="72.3245"
        width="21.0605"
        height="21.0436"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <filter
        id="filter7_i_1711_45594"
        x="58.7714"
        y="78.0366"
        width="9.62427"
        height="12.6174"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="5" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_45594"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1711_45594"
        x1="101.752"
        y1="60.7621"
        x2="120.966"
        y2="113.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1711_45594"
        x1="100.8"
        y1="107.745"
        x2="102.283"
        y2="128.479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoProductSearch = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="201"
    height="201"
    viewBox="0 0 201 201"
    fill="none"
  >
    <rect width="200" height="200" rx="100" fill="#F0F2FA" />
    <path
      d="M181.54 159.08C183.495 159.08 185.08 157.495 185.08 155.54C185.08 153.585 183.495 152 181.54 152C179.585 152 178 153.585 178 155.54C178 157.495 179.585 159.08 181.54 159.08Z"
      fill="white"
    />
    <path
      d="M180.035 22.0526C181.774 22.0526 183.185 20.6423 183.185 18.9026C183.185 17.1629 181.774 15.7526 180.035 15.7526C178.295 15.7526 176.885 17.1629 176.885 18.9026C176.885 20.6423 178.295 22.0526 180.035 22.0526Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 35.7526C171.751 35.7526 174.885 32.6186 174.885 28.7526C174.885 24.8866 171.751 21.7526 167.885 21.7526C164.019 21.7526 160.885 24.8866 160.885 28.7526C160.885 32.6186 164.019 35.7526 167.885 35.7526Z"
      fill="white"
    />
    <path
      d="M37.8848 185.753C41.7507 185.753 44.8848 182.619 44.8848 178.753C44.8848 174.887 41.7507 171.753 37.8848 171.753C34.0188 171.753 30.8848 174.887 30.8848 178.753C30.8848 182.619 34.0188 185.753 37.8848 185.753Z"
      fill="white"
    />
    <path
      d="M191.885 157C192.989 157 193.885 156.105 193.885 155C193.885 153.895 192.989 153 191.885 153C190.78 153 189.885 153.895 189.885 155C189.885 156.105 190.78 157 191.885 157Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.301C38.3573 30.301 40.6633 27.995 40.6633 25.1505C40.6633 22.306 38.3573 20 35.5128 20C32.6683 20 30.3623 22.306 30.3623 25.1505C30.3623 27.995 32.6683 30.301 35.5128 30.301Z"
      fill="white"
    />
    <path
      d="M19.0123 30.3C20.4759 30.3 21.6623 29.1136 21.6623 27.65C21.6623 26.1864 20.4759 25 19.0123 25C17.5487 25 16.3623 26.1864 16.3623 27.65C16.3623 29.1136 17.5487 30.3 19.0123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195C36.0475 195 37.3906 193.657 37.3906 192C37.3906 190.343 36.0475 189 34.3906 189C32.7338 189 31.3906 190.343 31.3906 192C31.3906 193.657 32.7338 195 34.3906 195Z"
      fill="#C5B8EA"
    />
    <g filter="url(#filter0_i_231_84886)">
      <path
        d="M157.896 170.553H38.2767C31.3514 170.553 26 165.784 26 160.219V38.3338C26 32.5045 31.6662 28 38.2767 28H157.896C164.822 28 170.173 32.7694 170.173 38.3338V160.219C170.173 165.784 164.507 170.553 157.896 170.553Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_i_231_84886)">
      <path
        d="M154.285 111.004C153.903 110.242 154.666 107.855 154.285 107.094C152.76 104.808 150.275 104.326 146.463 103.183C141.126 101.66 137.778 99.3654 133.585 98.9845C132.441 98.9845 131.297 98.6036 130.535 98.6036C118.717 97.461 108.806 95.5566 87.077 68.8956C84.7898 66.2295 83.6461 63.5634 81.3589 60.8973C79.0716 58.612 75.2595 61.2781 70.3038 62.4208C69.1601 62.8016 68.3977 62.8016 67.2541 62.8016C63.442 62.8016 58.8675 62.4208 54.6741 62.0399C48.956 61.2781 52.3869 58.2312 45.5251 102.031C45.1439 105.459 44.7627 108.506 44.3815 111.934C44.0002 114.6 44.0002 117.647 44.0002 120.313C44.0002 121.456 44.3815 123.36 45.5251 123.36C63.8232 125.265 75.6407 124.503 104.613 124.122C119.099 124.122 133.585 124.122 148.071 121.456L151.502 121.075C154.551 120.694 157.601 119.552 157.601 117.647C157.601 114.981 155.047 113.67 154.285 111.004Z"
        fill="#A9A6E2"
      />
    </g>
    <g filter="url(#filter2_i_231_84886)">
      <path
        d="M133.583 99.3657L130.152 109.268C111.473 108.507 92.4121 96.6996 82.5006 81.4647C79.0697 76.1325 76.4012 70.4194 72.5891 65.849C72.5891 65.849 71.4455 64.3255 69.9207 63.1828C74.8764 62.0402 78.6885 59.3741 80.9758 61.6594C82.8818 63.5637 83.6442 65.0872 85.1691 66.9916C85.5503 67.7533 85.9315 68.1342 86.3127 68.8959C86.3127 69.2768 86.6939 69.2768 86.6939 69.6577C87.8375 71.1812 89.3624 72.7047 90.506 74.2281C90.8872 74.609 91.2684 74.9899 91.6497 75.7516C93.1745 77.2751 94.3181 78.7986 95.843 80.3221C96.2242 80.703 96.6054 81.0838 96.9866 81.8456C98.5114 83.3691 99.6551 84.8926 101.18 86.0352C101.561 86.4161 102.324 86.7969 102.705 87.5587C104.23 88.7013 105.373 89.8439 106.517 90.9865C107.279 91.3674 107.66 91.7483 108.423 92.51C109.567 93.2718 110.329 94.0335 111.473 94.4144C112.235 94.7952 112.997 95.1761 113.379 95.557C115.285 96.6996 117.191 97.4614 119.097 98.2231C119.859 98.604 120.622 98.604 121.384 98.9848C124.434 99.7466 127.102 100.127 130.152 100.508C131.296 98.9848 132.439 98.9848 133.583 99.3657Z"
        fill="url(#paint0_linear_231_84886)"
      />
    </g>
    <g filter="url(#filter3_i_231_84886)">
      <path
        d="M157.601 118.028C157.601 119.933 154.17 121.075 151.501 121.456L148.07 121.837C133.966 124.503 119.098 124.503 104.612 124.503C75.6405 124.503 64.2042 125.265 45.5248 123.741C44 123.741 44 121.837 44 120.694C44 117.647 44 114.981 44.3812 112.315C54.6739 113.077 98.1319 115.362 131.297 111.934C140.446 110.792 148.833 109.649 155.313 107.745C155.695 108.507 156.076 109.268 156.457 110.03C157.22 112.315 157.601 114.981 157.601 118.028Z"
        fill="url(#paint1_linear_231_84886)"
      />
    </g>
    <g filter="url(#filter4_i_231_84886)">
      <path
        d="M156.458 109.65C149.596 111.936 142.734 113.459 135.491 113.84C134.348 113.84 133.204 113.84 132.442 113.459C131.298 113.078 131.298 112.317 130.917 111.555C130.917 111.174 130.917 110.793 130.917 110.412C130.536 106.603 130.155 102.414 130.155 98.6051C135.11 98.986 140.447 99.3669 146.928 101.652C150.74 102.795 153.408 104.699 154.933 107.365C155.696 108.127 156.077 108.889 156.458 109.65Z"
        fill="#F0EDFA"
      />
    </g>
    <path
      d="M86.3162 68.5158C86.3162 68.8967 86.3162 68.8967 86.3162 68.5158L81.3604 72.3246C80.9792 72.3246 80.9792 72.7054 80.598 72.7054C80.2168 72.7054 79.8356 72.7054 79.8356 72.3246C79.4544 71.9437 79.4544 71.1819 80.2168 70.8011L85.1726 66.9923H85.5538C85.5538 67.3732 85.935 68.135 86.3162 68.5158Z"
      fill="#F0EDFA"
    />
    <path
      d="M92.0316 74.9885C92.0316 75.3694 92.0316 75.3694 91.6504 75.7503C90.1256 77.2738 88.6007 78.7972 86.6947 80.3207C86.3135 80.3207 86.3135 80.7016 85.9323 80.7016C85.551 80.7016 85.1698 80.7016 85.1698 80.3207C84.7886 79.9399 84.7886 79.1781 85.551 78.7972C87.0759 77.6546 88.6007 76.1311 90.1256 74.6076C90.5068 74.2268 90.5068 74.2268 90.888 74.2268C90.888 74.2268 91.6504 74.6076 92.0316 74.9885Z"
      fill="#F0EDFA"
    />
    <path
      d="M96.9885 81.0832C96.9885 81.4641 96.9885 81.4641 96.6073 81.845C95.0825 83.3685 93.1764 85.2728 91.6516 86.7963C91.2704 87.1772 91.2704 87.1772 90.8891 87.1772C90.5079 87.1772 90.1267 87.1772 90.1267 86.7963C89.7455 86.4155 89.7455 85.6537 90.1267 85.2728C91.6516 83.7493 93.5576 81.845 95.0825 80.3215C95.4637 79.9406 95.4637 79.9406 95.8449 79.9406C96.2261 79.9406 96.6073 80.7024 96.9885 81.0832Z"
      fill="#F0EDFA"
    />
    <path
      d="M102.705 86.4171C102.705 86.7979 102.705 86.7979 102.323 87.1788C100.417 88.7023 98.5113 90.6067 97.3677 92.511C96.9865 92.8919 96.9865 92.8919 96.6052 92.8919C96.224 92.8919 96.224 92.8919 95.8428 92.511C95.4616 92.1302 95.0804 91.3684 95.4616 90.9875C96.9865 89.0832 98.8925 87.1788 100.799 85.2745C100.799 85.2745 101.18 85.2744 101.18 84.8936C101.942 85.6553 102.323 86.0362 102.705 86.4171Z"
      fill="#F0EDFA"
    />
    <path
      d="M108.422 90.9875C108.422 90.9875 108.422 91.3684 108.422 90.9875C107.279 93.2728 106.135 95.558 104.61 97.8432C104.229 98.2241 103.848 98.605 103.467 98.605H103.086C102.704 98.2241 102.323 97.4624 102.704 97.0815C103.848 94.7963 104.992 92.511 106.135 90.6067L106.516 90.2258C107.279 90.2258 107.66 90.6067 108.422 90.9875Z"
      fill="#F0EDFA"
    />
    <path
      d="M113.379 94.4148L112.236 101.27C112.236 102.032 111.473 102.413 111.092 102.413C110.33 102.413 109.948 101.651 109.948 100.89L111.092 93.2722C111.092 92.8913 111.092 92.8913 111.473 92.8913C112.236 93.653 112.617 94.0339 113.379 94.4148Z"
      fill="#F0EDFA"
    />
    <path
      d="M121.383 97.4615C121.002 99.3659 120.621 101.651 120.239 103.555C120.239 103.936 119.477 104.317 119.096 104.317C119.096 104.317 119.096 104.317 118.714 104.317C117.952 104.317 117.571 103.555 117.952 102.794C118.333 100.889 118.714 98.6041 119.096 96.6998C119.096 96.6998 119.096 96.6998 119.096 96.3189C119.858 97.0806 120.621 97.4615 121.383 97.4615Z"
      fill="#F0EDFA"
    />
    <g filter="url(#filter5_i_231_84886)">
      <path
        d="M64.5859 91.3682C69.8493 91.3682 74.1162 87.1051 74.1162 81.8464C74.1162 76.5876 69.8493 72.3245 64.5859 72.3245C59.3225 72.3245 55.0557 76.5876 55.0557 81.8464C55.0557 87.1051 59.3225 91.3682 64.5859 91.3682Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter6_i_231_84886)">
      <path
        d="M64.5833 85.6541C66.6887 85.6541 68.3954 83.9488 68.3954 81.8453C68.3954 79.7418 66.6887 78.0366 64.5833 78.0366C62.478 78.0366 60.7712 79.7418 60.7712 81.8453C60.7712 83.9488 62.478 85.6541 64.5833 85.6541Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter7_i_231_84886)">
      <path
        d="M145.745 182.603C165.519 182.603 181.55 166.573 181.55 146.799C181.55 127.024 165.519 110.994 145.745 110.994C125.971 110.994 109.94 127.024 109.94 146.799C109.94 166.573 125.971 182.603 145.745 182.603Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter8_i_231_84886)">
      <path
        d="M143.425 131.432C143.197 129.056 145.066 127 147.453 127C149.84 127 151.708 129.056 151.48 131.432L149.729 149.669C149.617 150.842 148.631 151.737 147.453 151.737C146.274 151.737 145.289 150.842 145.176 149.669L143.425 131.432Z"
        fill="url(#paint2_linear_231_84886)"
      />
    </g>
    <g filter="url(#filter9_i_231_84886)">
      <ellipse
        cx="147.453"
        cy="159.652"
        rx="4.45265"
        ry="3.95791"
        fill="url(#paint3_linear_231_84886)"
      />
    </g>
    <g filter="url(#filter10_i_231_84886)">
      <path
        d="M194.339 200.203C192.949 200.203 191.56 199.647 190.448 198.397L172.238 180.187L171.404 180.743C163.9 186.302 155.144 189.221 146.249 189.221C135.548 189.221 124.847 184.913 116.925 177.408C108.586 169.486 104 158.785 104 147.11C104 123.901 122.901 105 146.11 105C161.954 105 175.852 113.339 183.357 127.514C190.722 141.551 189.75 157.951 180.716 171.154L180.16 171.988L198.508 190.336C200.871 192.699 200.315 195.061 199.898 196.312C198.786 198.536 196.563 200.203 194.339 200.203ZM146.11 116.535C129.155 116.535 115.535 130.294 115.535 147.11C115.535 166.289 131.24 177.825 146.527 177.825C155.839 177.825 164.317 173.655 170.293 166.15C177.659 156.978 178.909 144.609 173.767 133.907C168.486 123.206 157.924 116.535 146.11 116.535Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_231_84886"
        x="26"
        y="23.7864"
        width="144.173"
        height="146.767"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4.21361" />
        <feGaussianBlur stdDeviation="7.49086" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter1_i_231_84886"
        x="44.0002"
        y="51"
        width="122.601"
        height="73.5981"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="16" dy="-20" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter2_i_231_84886"
        x="69.9207"
        y="56.7621"
        width="66.6621"
        height="52.5063"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-5" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter3_i_231_84886"
        x="44"
        y="107.745"
        width="116.601"
        height="19.9488"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter4_i_231_84886"
        x="128.155"
        y="98.6051"
        width="28.3035"
        height="20.2349"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="5" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter5_i_231_84886"
        x="55.0557"
        y="72.3245"
        width="21.0605"
        height="21.0436"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter6_i_231_84886"
        x="58.7712"
        y="78.0366"
        width="9.62427"
        height="12.6174"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="5" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter7_i_231_84886"
        x="109.94"
        y="106.994"
        width="75.6094"
        height="75.6093"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter8_i_231_84886"
        x="143.407"
        y="125"
        width="11.092"
        height="26.7369"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter9_i_231_84886"
        x="143"
        y="153.694"
        width="11.9053"
        height="9.91582"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <filter
        id="filter10_i_231_84886"
        x="104"
        y="102"
        width="99.2708"
        height="98.2034"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-4" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_84886"
        />
      </filter>
      <linearGradient
        id="paint0_linear_231_84886"
        x1="101.752"
        y1="60.7621"
        x2="120.966"
        y2="113.39"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_231_84886"
        x1="100.8"
        y1="107.745"
        x2="102.283"
        y2="128.479"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_231_84886"
        x1="147.453"
        y1="127"
        x2="162.06"
        y2="137.974"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_231_84886"
        x1="147.453"
        y1="155.694"
        x2="150.962"
        y2="163.933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoTemplate = (
  <svg
    width="200"
    height="201"
    viewBox="0 0 200 201"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 200.5C155.227 200.5 200 155.815 200 100.5C200 45.185 155.03 0.5 100 0.5C44.7732 0.5 0 45.185 0 100.5C0 155.815 44.7732 200.5 100 200.5Z"
      fill="url(#paint0_linear_1729_56306)"
    />
    <path
      d="M152.789 187.641C155.536 187.641 157.763 185.406 157.763 182.649C157.763 179.892 155.536 177.657 152.789 177.657C150.042 177.657 147.815 179.892 147.815 182.649C147.815 185.406 150.042 187.641 152.789 187.641Z"
      fill="#DCDAE3"
    />
    <path
      d="M157.734 17.8983C159.394 17.8983 160.74 16.5477 160.74 14.8818C160.74 13.2158 159.394 11.8652 157.734 11.8652C156.074 11.8652 154.728 13.2158 154.728 14.8818C154.728 16.5477 156.074 17.8983 157.734 17.8983Z"
      fill="#C5B8EA"
    />
    <path
      d="M147.316 28.3935C150.5 28.3935 153.081 25.8034 153.081 22.6084C153.081 19.4133 150.5 16.8232 147.316 16.8232C144.133 16.8232 141.552 19.4133 141.552 22.6084C141.552 25.8034 144.133 28.3935 147.316 28.3935Z"
      fill="white"
    />
    <path
      d="M39.4346 171.37C42.6183 171.37 45.1993 168.78 45.1993 165.585C45.1993 162.39 42.6183 159.8 39.4346 159.8C36.2508 159.8 33.6699 162.39 33.6699 165.585C33.6699 168.78 36.2508 171.37 39.4346 171.37Z"
      fill="white"
    />
    <path
      d="M162.223 190.053C163.132 190.053 163.87 189.313 163.87 188.4C163.87 187.487 163.132 186.747 162.223 186.747C161.313 186.747 160.576 187.487 160.576 188.4C160.576 189.313 161.313 190.053 162.223 190.053Z"
      fill="#C5B8EA"
    />
    <path
      d="M38.3046 21.4087C40.6471 21.4087 42.5461 19.503 42.5461 17.1521C42.5461 14.8013 40.6471 12.8955 38.3046 12.8955C35.962 12.8955 34.063 14.8013 34.063 17.1521C34.063 19.503 35.962 21.4087 38.3046 21.4087Z"
      fill="#C5B8EA"
    />
    <path
      d="M24.716 23.8885C25.9213 23.8885 26.8984 22.9079 26.8984 21.6984C26.8984 20.4888 25.9213 19.5083 24.716 19.5083C23.5108 19.5083 22.5337 20.4888 22.5337 21.6984C22.5337 22.9079 23.5108 23.8885 24.716 23.8885Z"
      fill="#DCDAE3"
    />
    <path
      d="M26.6745 176.533C28.4938 176.533 29.9686 175.053 29.9686 173.227C29.9686 171.401 28.4938 169.921 26.6745 169.921C24.8552 169.921 23.3804 171.401 23.3804 173.227C23.3804 175.053 24.8552 176.533 26.6745 176.533Z"
      fill="#C5B8EA"
    />
    <g filter="url(#filter0_i_1729_56306)">
      <path
        d="M119.272 52.7811L143.838 141.089C144.641 144.139 142.874 147.19 139.824 147.993L53.2825 170.952C50.2319 171.755 47.1813 169.989 46.3785 166.939L16.1934 52.9416C15.3906 49.891 17.1567 46.8404 20.2073 46.0376L82.8253 29.5L119.272 52.7811Z"
        fill="url(#paint1_linear_1729_56306)"
      />
    </g>
    <g filter="url(#filter1_i_1729_56306)">
      <path
        d="M117.987 108.655L71.2646 121.018L66.1267 122.302L50.5525 126.477C49.9102 126.637 49.4286 127.44 49.7497 128.243C49.9102 129.046 50.713 129.527 51.3553 129.367L66.9295 125.192L72.0674 123.908L118.79 111.545C119.432 111.384 119.914 110.581 119.593 109.779C119.432 108.976 118.629 108.494 117.987 108.655Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_i_1729_56306)">
      <path
        d="M114.936 97.7369L97.5953 102.233L91.6546 103.838L47.822 115.559C47.1798 115.719 46.6981 116.522 47.0192 117.325C47.1798 118.128 47.9826 118.61 48.6248 118.449L92.618 106.728L98.5586 105.123L115.899 100.627C116.541 100.466 117.023 99.6636 116.702 98.8608C116.381 98.2185 115.578 97.5763 114.936 97.7369Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter3_i_1729_56306)">
      <path
        d="M112.368 86.659L107.872 87.783L103.376 88.9069L44.7722 104.481C44.13 104.642 43.6483 105.444 43.9694 106.247C44.13 107.05 44.9328 107.532 45.575 107.371L104.179 91.7969L109.156 90.5125L113.17 89.3886C113.813 89.228 114.294 88.4252 113.973 87.6224C113.813 86.9802 113.17 86.4985 112.368 86.659Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter4_i_1729_56306)">
      <path
        d="M85.2327 143.497L82.0215 144.3C81.3793 144.461 80.5765 143.979 80.4159 143.176C80.2554 142.374 80.5765 141.571 81.2187 141.41L84.4299 140.607C85.0721 140.447 85.8749 140.929 86.0355 141.731C86.196 142.695 85.8749 143.337 85.2327 143.497Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter5_i_1729_56306)">
      <path
        d="M75.4394 146.066L56.9751 150.883C56.3329 151.043 55.5301 150.562 55.3695 149.759C55.209 148.956 55.5301 148.153 56.1723 147.993L74.6366 143.176C75.2788 143.015 76.0816 143.497 76.2422 144.3C76.5633 145.102 76.2422 145.905 75.4394 146.066Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter6_i_1729_56306)">
      <path
        d="M110.12 75.5801L95.5088 79.4335L91.9765 80.3969L42.0427 93.5627C41.4005 93.7233 40.9188 94.5261 41.2399 95.3289C41.4005 96.1317 42.2033 96.6134 42.8455 96.4528L92.6188 83.4475L96.1511 82.4842L110.601 78.6308C111.404 78.4702 111.725 77.6674 111.565 76.704C111.565 76.0618 110.762 75.4196 110.12 75.5801Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter7_i_1729_56306)">
      <path
        d="M75.5988 51.3356L34.1746 62.2536C33.2113 62.5747 32.2479 61.9325 31.9268 60.9691C31.6057 60.0057 32.2479 59.0424 33.2113 58.7213L74.6355 47.8033C75.5988 47.4821 76.5622 48.1244 76.8833 49.0877C77.2044 50.0511 76.5622 51.0144 75.5988 51.3356Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter8_i_1729_56306)">
      <path
        d="M52.8004 68.0343L36.9051 72.2088C35.9417 72.5299 34.9784 71.8877 34.6573 70.9243C34.3361 69.961 34.9784 68.9976 35.9417 68.6765L51.6765 64.502C52.6399 64.1809 53.6032 64.8231 53.9243 65.7865C54.2455 66.7498 53.6032 67.7132 52.8004 68.0343Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter9_i_1729_56306)">
      <path
        d="M82.8257 29.5L89.248 53.905C90.2114 57.2767 93.9043 59.364 97.276 58.4006L119.273 52.7811"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter10_i_1729_56306)">
      <path
        d="M183.503 77.1419L168.732 167.697C168.25 170.748 165.199 172.835 162.149 172.193L74.1623 156.779C71.1117 156.297 69.0245 153.247 69.5061 150.196L89.8971 34.112C90.3788 31.0614 93.4294 28.9742 96.48 29.6164L160.383 40.8555L183.503 77.1419Z"
        fill="url(#paint2_linear_1729_56306)"
      />
    </g>
    <g filter="url(#filter11_i_1729_56306)">
      <path
        d="M159.571 127.922L112.046 119.573L106.908 118.61L91.0128 115.88C90.3705 115.72 89.5677 116.362 89.5677 117.165C89.4072 117.968 89.8889 118.77 90.5311 118.931L106.426 121.66L111.564 122.624L159.09 130.973C159.732 131.133 160.535 130.491 160.535 129.688C160.695 128.886 160.374 128.083 159.571 127.922Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter12_i_1729_56306)">
      <path
        d="M161.499 116.844L143.837 113.793L137.897 112.669L93.1007 104.802C92.4584 104.641 91.6556 105.283 91.6556 106.086C91.4951 106.889 91.9767 107.692 92.619 107.852L137.415 115.72L143.356 116.844L161.017 119.894C161.659 120.055 162.462 119.412 162.462 118.61C162.623 117.807 162.141 117.004 161.499 116.844Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter13_i_1729_56306)">
      <path
        d="M163.747 105.604L159.091 104.801L154.435 103.999L94.7071 93.5624C94.0649 93.4018 93.2621 94.044 93.2621 94.8468C93.1015 95.6496 93.5832 96.4524 94.2254 96.613L153.953 107.049L159.091 108.013L163.105 108.655C163.747 108.815 164.55 108.173 164.55 107.37C164.871 106.568 164.55 105.765 163.747 105.604Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter14_i_1729_56306)">
      <path
        d="M115.259 145.904L112.048 145.422C111.405 145.262 110.924 144.459 111.084 143.656C111.245 142.853 111.887 142.211 112.529 142.371L115.741 142.853C116.383 143.014 116.864 143.816 116.704 144.619C116.543 145.583 115.901 145.904 115.259 145.904Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter15_i_1729_56306)">
      <path
        d="M105.464 144.14L86.6786 140.929C86.0363 140.768 85.5546 139.966 85.7152 139.163C85.8758 138.36 86.518 137.718 87.1602 137.878L105.946 141.089C106.588 141.25 107.07 142.053 106.909 142.856C106.748 143.819 106.106 144.301 105.464 144.14Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter16_i_1729_56306)">
      <path
        d="M166.315 94.6872L151.383 92.1183L147.69 91.476L96.7926 82.4847C96.1503 82.3242 95.3475 82.9664 95.3475 83.7692C95.187 84.572 95.6686 85.3748 96.3109 85.5353L147.208 94.5267L150.901 95.1689L165.672 97.7378C166.475 97.8984 167.117 97.2562 167.278 96.4534C167.439 95.6506 166.957 94.8478 166.315 94.6872Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter17_i_1729_56306)">
      <path
        d="M145.282 58.2404L103.055 50.8547C102.092 50.6942 101.449 49.7308 101.61 48.7675C101.771 47.8041 102.734 47.1619 103.697 47.3224L145.924 54.7082C146.888 54.8687 147.53 55.8321 147.369 56.7954C147.209 57.5982 146.245 58.401 145.282 58.2404Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter18_i_1729_56306)">
      <path
        d="M117.506 63.6984L101.289 60.8084C100.326 60.6478 99.6839 59.6844 99.8444 58.7211C100.005 57.7577 100.968 57.1155 101.932 57.2761L117.988 60.1661C118.951 60.3267 119.593 61.29 119.433 62.2534C119.272 63.2167 118.309 63.859 117.506 63.6984Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter19_i_1729_56306)">
      <path
        d="M160.858 41.3818L156.523 66.2685C155.881 69.8008 158.45 73.1725 161.982 73.8148L184.139 77.6682"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter20_i_1729_56306)">
      <path
        d="M123.606 156.9C143.381 156.9 159.411 140.87 159.411 121.095C159.411 101.321 143.381 85.2905 123.606 85.2905C103.832 85.2905 87.8018 101.321 87.8018 121.095C87.8018 140.87 103.832 156.9 123.606 156.9Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter21_i_1729_56306)">
      <path
        d="M124.335 128.69C123.101 128.69 122.075 127.836 122.075 126.603C122.075 123.873 123.199 121.465 126.089 119.378L128.498 117.612C129.943 116.488 130.585 115.203 130.585 113.598C130.585 111.35 128.979 109.102 125.608 109.102C122.075 109.102 120.47 111.992 120.47 114.721C120.47 115.51 119.798 116.306 119.01 116.287L116.444 116.222C115.123 116.189 113.895 115.28 113.887 113.958C113.887 113.945 113.887 113.932 113.887 113.919C113.887 108.46 117.901 103.322 125.447 103.322C133.154 103.322 137.328 108.299 137.328 113.276C137.328 117.29 135.241 120.02 132.351 122.107L130.264 123.552C128.498 124.837 127.534 126.442 127.534 128.369C127.534 128.546 127.39 128.69 127.213 128.69H124.335ZM124.965 131.901C127.213 131.901 128.979 133.667 128.979 135.915C128.979 138.163 127.213 139.929 124.965 139.929C122.717 139.929 120.951 138.163 120.951 135.915C121.112 133.828 122.717 131.901 124.965 131.901Z"
        fill="url(#paint3_linear_1729_56306)"
      />
    </g>
    <g filter="url(#filter22_i_1729_56306)">
      <path
        d="M177.2 179.5C175.811 179.5 174.421 178.944 173.309 177.693L150.1 154.484L149.266 155.04C141.761 160.599 133.005 163.517 124.111 163.517C113.409 163.517 102.708 159.209 94.7863 151.704C86.4476 143.782 81.8613 133.081 81.8613 121.407C81.8613 98.1974 100.762 79.2964 123.972 79.2964C139.815 79.2964 153.713 87.6351 161.218 101.811C168.584 115.848 167.611 132.247 158.577 145.45L158.021 146.284L181.37 169.632C183.732 171.995 183.177 174.358 182.76 175.608C181.648 177.832 179.424 179.5 177.2 179.5ZM123.972 90.8316C107.016 90.8316 93.3965 104.59 93.3965 121.407C93.3965 140.586 109.101 152.121 124.389 152.121C133.7 152.121 142.178 147.952 148.154 140.447C155.52 131.274 156.771 118.905 151.628 108.204C146.347 97.5025 135.785 90.8316 123.972 90.8316Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1729_56306"
        x="16"
        y="16.5"
        width="138.031"
        height="154.646"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-13" />
        <feGaussianBlur stdDeviation="25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter1_i_1729_56306"
        x="49.6475"
        y="108.624"
        width="72.0474"
        height="21.7734"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter2_i_1729_56306"
        x="46.917"
        y="97.7119"
        width="71.8872"
        height="21.7681"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter3_i_1729_56306"
        x="43.8672"
        y="86.6279"
        width="72.208"
        height="21.7739"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter4_i_1729_56306"
        x="80.375"
        y="140.577"
        width="7.70117"
        height="4.75439"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter5_i_1729_56306"
        x="55.3286"
        y="143.145"
        width="23.0366"
        height="8.76855"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter6_i_1729_56306"
        x="41.1377"
        y="75.5552"
        width="72.4673"
        height="21.9282"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter7_i_1729_56306"
        x="31.8433"
        y="47.7197"
        width="47.1235"
        height="15.6172"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter8_i_1729_56306"
        x="34.5737"
        y="64.4185"
        width="21.4351"
        height="8.87402"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter9_i_1729_56306"
        x="82.8257"
        y="29.5"
        width="36.4468"
        height="33.1362"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter10_i_1729_56306"
        x="69.437"
        y="16.5"
        width="124.066"
        height="155.809"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-13" />
        <feGaussianBlur stdDeviation="25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter11_i_1729_56306"
        x="89.5366"
        y="115.855"
        width="74.0386"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter12_i_1729_56306"
        x="91.6245"
        y="104.777"
        width="73.8687"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter13_i_1729_56306"
        x="93.231"
        y="93.5376"
        width="74.4424"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter14_i_1729_56306"
        x="111.053"
        y="142.347"
        width="8.68164"
        height="5.55713"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter15_i_1729_56306"
        x="85.6841"
        y="137.854"
        width="24.2559"
        height="8.31689"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter16_i_1729_56306"
        x="95.3164"
        y="82.46"
        width="74.9927"
        height="17.3027"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter17_i_1729_56306"
        x="101.585"
        y="47.2979"
        width="48.8086"
        height="12.9634"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter18_i_1729_56306"
        x="99.8198"
        y="57.2515"
        width="22.6372"
        height="8.47168"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter19_i_1729_56306"
        x="156.424"
        y="41.3818"
        width="27.7148"
        height="40.2861"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter20_i_1729_56306"
        x="87.8018"
        y="81.2905"
        width="75.6094"
        height="75.6094"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter21_i_1729_56306"
        x="113.887"
        y="101.322"
        width="26.4414"
        height="38.6074"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <filter
        id="filter22_i_1729_56306"
        x="81.8613"
        y="76.2964"
        width="104.271"
        height="103.204"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-4" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1729_56306"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1729_56306"
        x1="66.6666"
        y1="-62"
        x2="250"
        y2="400.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0EDFA" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1729_56306"
        x1="80.0156"
        y1="29.5"
        x2="152.09"
        y2="165.459"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1729_56306"
        x1="126.47"
        y1="29.5"
        x2="203.934"
        y2="158.627"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1729_56306"
        x1="125.608"
        y1="103.322"
        x2="147.2"
        y2="132.177"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoSearchTemp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="169"
    height="150"
    viewBox="0 0 169 150"
    fill="none"
  >
    <g filter="url(#filter0_i_548_49378)">
      <path
        d="M103.272 23.2811L127.838 111.589C128.641 114.639 126.874 117.69 123.824 118.493L37.2825 141.452C34.2319 142.255 31.1813 140.489 30.3785 137.439L0.193367 23.4416C-0.609428 20.391 1.15672 17.3404 4.20734 16.5376L66.8253 0L103.272 23.2811Z"
        fill="url(#paint0_linear_548_49378)"
      />
    </g>
    <g filter="url(#filter1_i_548_49378)">
      <path
        d="M101.987 79.1546L55.2646 91.5176L50.1267 92.8021L34.5525 96.9766C33.9102 97.1372 33.4286 97.94 33.7497 98.7428C33.9102 99.5456 34.713 100.027 35.3553 99.8667L50.9295 95.6921L56.0674 94.4077L102.79 82.0446C103.432 81.8841 103.914 81.0813 103.593 80.2785C103.432 79.4757 102.629 78.994 101.987 79.1546Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_i_548_49378)">
      <path
        d="M98.9357 68.2368L81.5953 72.7325L75.6546 74.3381L31.822 86.0589C31.1798 86.2194 30.6981 87.0222 31.0192 87.825C31.1798 88.6278 31.9826 89.1095 32.6248 88.9489L76.618 77.2281L82.5586 75.6225L99.899 71.1269C100.541 70.9663 101.023 70.1635 100.702 69.3607C100.381 68.7185 99.5779 68.0763 98.9357 68.2368Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter3_i_548_49378)">
      <path
        d="M96.3675 57.1592L91.8719 58.2831L87.3762 59.407L28.7722 74.9812C28.13 75.1418 27.6483 75.9446 27.9694 76.7474C28.13 77.5502 28.9328 78.0319 29.575 77.8713L88.179 62.2971L93.1563 61.0126L97.1703 59.8887C97.8126 59.7281 98.2942 58.9253 97.9731 58.1226C97.8126 57.4803 97.1703 56.9986 96.3675 57.1592Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter4_i_548_49378)">
      <path
        d="M69.2327 113.997L66.0215 114.8C65.3793 114.961 64.5765 114.479 64.4159 113.676C64.2554 112.873 64.5765 112.071 65.2187 111.91L68.4299 111.107C69.0721 110.947 69.8749 111.428 70.0355 112.231C70.196 113.195 69.8749 113.837 69.2327 113.997Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter5_i_548_49378)">
      <path
        d="M59.4394 116.566L40.9751 121.383C40.3329 121.543 39.5301 121.061 39.3695 120.259C39.209 119.456 39.5301 118.653 40.1723 118.492L58.6366 113.676C59.2788 113.515 60.0816 113.997 60.2422 114.8C60.5633 115.602 60.2422 116.405 59.4394 116.566Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter6_i_548_49378)">
      <path
        d="M94.1197 46.08L79.5088 49.9334L75.9765 50.8967L26.0427 64.0626C25.4005 64.2231 24.9188 65.0259 25.2399 65.8287C25.4005 66.6315 26.2033 67.1132 26.8455 66.9526L76.6188 53.9474L80.1511 52.984L94.6014 49.1306C95.4042 48.97 95.7253 48.1672 95.5647 47.2039C95.5647 46.5617 94.7619 45.9194 94.1197 46.08Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter7_i_548_49378)">
      <path
        d="M59.5988 21.8357L18.1746 32.7537C17.2113 33.0748 16.2479 32.4326 15.9268 31.4692C15.6057 30.5059 16.2479 29.5425 17.2113 29.2214L58.6355 18.3034C59.5988 17.9823 60.5622 18.6245 60.8833 19.5879C61.2044 20.5512 60.5622 21.5146 59.5988 21.8357Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter8_i_548_49378)">
      <path
        d="M36.8004 38.5344L20.9051 42.709C19.9417 43.0301 18.9784 42.3878 18.6573 41.4245C18.3361 40.4611 18.9784 39.4978 19.9417 39.1767L35.6765 35.0021C36.6399 34.681 37.6032 35.3232 37.9243 36.2866C38.2455 37.25 37.6032 38.2133 36.8004 38.5344Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter9_i_548_49378)">
      <path
        d="M66.8257 0L73.248 24.405C74.2114 27.7767 77.9043 29.864 81.276 28.9006L103.273 23.2811"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter10_i_548_49378)">
      <path
        d="M167.503 47.6419L152.732 138.197C152.25 141.248 149.199 143.335 146.149 142.693L58.1623 127.279C55.1117 126.797 53.0245 123.747 53.5061 120.696L73.8971 4.61204C74.3788 1.56142 77.4294 -0.525846 80.48 0.11639L144.383 11.3555L167.503 47.6419Z"
        fill="url(#paint1_linear_548_49378)"
      />
    </g>
    <g filter="url(#filter11_i_548_49378)">
      <path
        d="M143.571 98.4222L96.046 90.0731L90.9081 89.1097L75.0128 86.3802C74.3705 86.2197 73.5677 86.8619 73.5677 87.6647C73.4072 88.4675 73.8889 89.2703 74.5311 89.4309L90.4264 92.1604L95.5643 93.1237L143.09 101.473C143.732 101.633 144.535 100.991 144.535 100.188C144.695 99.3855 144.374 98.5827 143.571 98.4222Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter12_i_548_49378)">
      <path
        d="M145.499 87.3437L127.837 84.2931L121.897 83.1692L77.1007 75.3018C76.4584 75.1412 75.6556 75.7835 75.6556 76.5863C75.4951 77.3891 75.9767 78.1919 76.619 78.3524L121.415 86.2198L127.356 87.3437L145.017 90.3943C145.659 90.5549 146.462 89.9127 146.462 89.1099C146.623 88.3071 146.141 87.5043 145.499 87.3437Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter13_i_548_49378)">
      <path
        d="M147.747 76.1042L143.091 75.3014L138.435 74.4986L78.7071 64.0622C78.0649 63.9017 77.2621 64.5439 77.2621 65.3467C77.1015 66.1495 77.5832 66.9523 78.2254 67.1129L137.953 77.5492L143.091 78.5125L147.105 79.1548C147.747 79.3153 148.55 78.6731 148.55 77.8703C148.871 77.0675 148.55 76.2647 147.747 76.1042Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter14_i_548_49378)">
      <path
        d="M99.2589 116.404L96.0477 115.922C95.4055 115.762 94.9238 114.959 95.0843 114.156C95.2449 113.353 95.8871 112.711 96.5294 112.872L99.7406 113.353C100.383 113.514 100.864 114.317 100.704 115.119C100.543 116.083 99.9011 116.404 99.2589 116.404Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter15_i_548_49378)">
      <path
        d="M89.464 114.64L70.6786 111.429C70.0363 111.268 69.5546 110.465 69.7152 109.663C69.8758 108.86 70.518 108.218 71.1602 108.378L89.9456 111.589C90.5879 111.75 91.0696 112.553 90.909 113.355C90.7484 114.319 90.1062 114.8 89.464 114.64Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter16_i_548_49378)">
      <path
        d="M150.315 65.1874L135.383 62.6184L131.69 61.9762L80.7926 52.9849C80.1503 52.8243 79.3475 53.4666 79.3475 54.2694C79.187 55.0721 79.6686 55.8749 80.3109 56.0355L131.208 65.0268L134.901 65.669L149.672 68.238C150.475 68.3985 151.117 67.7563 151.278 66.9535C151.439 66.1507 150.957 65.3479 150.315 65.1874Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter17_i_548_49378)">
      <path
        d="M129.282 28.7403L87.0551 21.3546C86.0917 21.194 85.4495 20.2306 85.61 19.2673C85.7706 18.3039 86.734 17.6617 87.6973 17.8223L129.924 25.208C130.888 25.3685 131.53 26.3319 131.369 27.2952C131.209 28.098 130.245 28.9008 129.282 28.7403Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter18_i_548_49378)">
      <path
        d="M101.506 34.1984L85.2894 31.3083C84.3261 31.1477 83.6839 30.1844 83.8444 29.221C84.005 28.2577 84.9683 27.6154 85.9317 27.776L101.988 30.6661C102.951 30.8266 103.593 31.79 103.433 32.7533C103.272 33.7167 102.309 34.3589 101.506 34.1984Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter19_i_548_49378)">
      <path
        d="M144.858 11.8819L140.523 36.7686C139.881 40.3009 142.45 43.6726 145.982 44.3149L168.139 48.1683"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter20_i_548_49378)">
      <path
        d="M107.606 127.4C127.381 127.4 143.411 111.37 143.411 91.5953C143.411 71.821 127.381 55.7907 107.606 55.7907C87.832 55.7907 71.8018 71.821 71.8018 91.5953C71.8018 111.37 87.832 127.4 107.606 127.4Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter21_i_548_49378)">
      <path
        d="M108.335 99.1902C107.101 99.1902 106.075 98.3365 106.075 97.1029C106.075 94.3734 107.199 91.965 110.089 89.8777L112.498 88.1116C113.943 86.9877 114.585 85.7032 114.585 84.0976C114.585 81.8498 112.979 79.602 109.608 79.602C106.075 79.602 104.47 82.492 104.47 85.2215C104.47 86.0102 103.798 86.8063 103.01 86.7866L100.444 86.7225C99.1226 86.6894 97.8955 85.78 97.8868 84.4584C97.8868 84.4452 97.8867 84.432 97.8867 84.4187C97.8867 78.9597 101.901 73.8218 109.447 73.8218C117.154 73.8218 121.328 78.7992 121.328 83.7765C121.328 87.7905 119.241 90.52 116.351 92.6072L114.264 94.0523C112.498 95.3367 111.534 96.9423 111.534 98.869C111.534 99.0464 111.39 99.1902 111.213 99.1902H108.335ZM108.965 102.401C111.213 102.401 112.979 104.167 112.979 106.415C112.979 108.663 111.213 110.429 108.965 110.429C106.717 110.429 104.951 108.663 104.951 106.415C105.112 104.328 106.717 102.401 108.965 102.401Z"
        fill="url(#paint2_linear_548_49378)"
      />
    </g>
    <g filter="url(#filter22_i_548_49378)">
      <path
        d="M161.2 150C159.811 150 158.421 149.444 157.309 148.193L134.1 124.984L133.266 125.54C125.761 131.099 117.005 134.017 108.111 134.017C97.4094 134.017 86.7081 129.709 78.7863 122.204C70.4476 114.282 65.8613 103.581 65.8613 91.907C65.8613 68.6976 84.7624 49.7965 107.972 49.7965C123.815 49.7965 137.713 58.1352 145.218 72.311C152.584 86.3478 151.611 102.747 142.577 115.95L142.021 116.784L165.37 140.132C167.732 142.495 167.177 144.858 166.76 146.109C165.648 148.332 163.424 150 161.2 150ZM107.972 61.3317C91.0164 61.3317 77.3965 75.0906 77.3965 91.907C77.3965 111.086 93.1011 122.621 108.389 122.621C117.7 122.621 126.178 118.452 132.154 110.947C139.52 101.774 140.771 89.4054 135.628 78.704C130.347 68.0027 119.785 61.3317 107.972 61.3317Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_548_49378"
        x="0"
        y="-13"
        width="138.031"
        height="154.646"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-13" />
        <feGaussianBlur stdDeviation="25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter1_i_548_49378"
        x="33.6475"
        y="79.1238"
        width="72.0474"
        height="21.7736"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter2_i_548_49378"
        x="30.917"
        y="68.2119"
        width="71.8872"
        height="21.7678"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter3_i_548_49378"
        x="27.8672"
        y="57.1281"
        width="72.208"
        height="21.774"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter4_i_548_49378"
        x="64.375"
        y="111.076"
        width="7.70117"
        height="4.75439"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter5_i_548_49378"
        x="39.3286"
        y="113.645"
        width="23.0366"
        height="8.76836"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter6_i_548_49378"
        x="25.1377"
        y="46.055"
        width="72.4673"
        height="21.9284"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter7_i_548_49378"
        x="15.8433"
        y="18.2198"
        width="47.1235"
        height="15.6174"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter8_i_548_49378"
        x="18.5737"
        y="34.9186"
        width="21.4351"
        height="8.87389"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter9_i_548_49378"
        x="66.8257"
        y="0"
        width="36.4468"
        height="33.1363"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter10_i_548_49378"
        x="53.437"
        y="-13"
        width="124.066"
        height="155.809"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-13" />
        <feGaussianBlur stdDeviation="25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter11_i_548_49378"
        x="73.5366"
        y="86.3555"
        width="74.0386"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter12_i_548_49378"
        x="75.6245"
        y="75.277"
        width="73.8687"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter13_i_548_49378"
        x="77.231"
        y="64.0375"
        width="74.4424"
        height="17.1421"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter14_i_548_49378"
        x="95.0532"
        y="112.847"
        width="8.68164"
        height="5.55708"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter15_i_548_49378"
        x="69.6841"
        y="108.353"
        width="24.2559"
        height="8.31699"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter16_i_548_49378"
        x="79.3164"
        y="52.9601"
        width="74.9927"
        height="17.3026"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter17_i_548_49378"
        x="85.5854"
        y="17.7977"
        width="48.8086"
        height="12.9633"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter18_i_548_49378"
        x="83.8198"
        y="27.7514"
        width="22.6372"
        height="8.47154"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="4" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter19_i_548_49378"
        x="140.424"
        y="11.8819"
        width="27.7148"
        height="40.2863"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter20_i_548_49378"
        x="71.8018"
        y="51.7907"
        width="75.6094"
        height="75.6093"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter21_i_548_49378"
        x="97.8867"
        y="71.8218"
        width="26.4414"
        height="38.6075"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <filter
        id="filter22_i_548_49378"
        x="65.8613"
        y="46.7965"
        width="104.271"
        height="103.203"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-4" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_548_49378"
        />
      </filter>
      <linearGradient
        id="paint0_linear_548_49378"
        x1="64.0156"
        y1="-2.11069e-06"
        x2="136.09"
        y2="135.959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_548_49378"
        x1="110.47"
        y1="-2.12802e-06"
        x2="187.934"
        y2="129.127"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_548_49378"
        x1="109.608"
        y1="73.8218"
        x2="131.2"
        y2="102.677"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoSearchOrder = (
  <svg
    width="201"
    height="201"
    viewBox="0 0 201 201"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="200" height="200" rx="100" fill="#F0F2FA" />
    <path
      d="M181.54 159.58C183.495 159.58 185.08 157.995 185.08 156.04C185.08 154.085 183.495 152.5 181.54 152.5C179.585 152.5 178 154.085 178 156.04C178 157.995 179.585 159.58 181.54 159.58Z"
      fill="white"
    />
    <path
      d="M180.035 22.5526C181.774 22.5526 183.185 21.1423 183.185 19.4026C183.185 17.6629 181.774 16.2526 180.035 16.2526C178.295 16.2526 176.885 17.6629 176.885 19.4026C176.885 21.1423 178.295 22.5526 180.035 22.5526Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 36.2526C171.751 36.2526 174.885 33.1186 174.885 29.2526C174.885 25.3866 171.751 22.2526 167.885 22.2526C164.019 22.2526 160.885 25.3866 160.885 29.2526C160.885 33.1186 164.019 36.2526 167.885 36.2526Z"
      fill="white"
    />
    <path
      d="M37.8848 186.253C41.7507 186.253 44.8848 183.119 44.8848 179.253C44.8848 175.387 41.7507 172.253 37.8848 172.253C34.0188 172.253 30.8848 175.387 30.8848 179.253C30.8848 183.119 34.0188 186.253 37.8848 186.253Z"
      fill="white"
    />
    <path
      d="M191.885 157.5C192.989 157.5 193.885 156.605 193.885 155.5C193.885 154.395 192.989 153.5 191.885 153.5C190.78 153.5 189.885 154.395 189.885 155.5C189.885 156.605 190.78 157.5 191.885 157.5Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.801C38.3573 30.801 40.6633 28.495 40.6633 25.6505C40.6633 22.806 38.3573 20.5 35.5128 20.5C32.6683 20.5 30.3623 22.806 30.3623 25.6505C30.3623 28.495 32.6683 30.801 35.5128 30.801Z"
      fill="white"
    />
    <path
      d="M19.0123 30.8C20.4759 30.8 21.6623 29.6136 21.6623 28.15C21.6623 26.6864 20.4759 25.5 19.0123 25.5C17.5487 25.5 16.3623 26.6864 16.3623 28.15C16.3623 29.6136 17.5487 30.8 19.0123 30.8Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195.5C36.0475 195.5 37.3906 194.157 37.3906 192.5C37.3906 190.843 36.0475 189.5 34.3906 189.5C32.7338 189.5 31.3906 190.843 31.3906 192.5C31.3906 194.157 32.7338 195.5 34.3906 195.5Z"
      fill="#C5B8EA"
    />
    <path
      d="M28.6392 68.3477H178.457V161.849C178.457 163.047 178.262 164.234 177.883 165.341C177.504 166.447 176.948 167.453 176.247 168.3C175.546 169.148 174.714 169.82 173.798 170.278C172.883 170.737 171.901 170.972 170.91 170.972H36.1861C35.195 170.972 34.2136 170.737 33.298 170.278C32.3823 169.82 31.5504 169.148 30.8496 168.3C30.1488 167.453 29.5929 166.447 29.2136 165.341C28.8344 164.234 28.6392 163.047 28.6392 161.849V68.3477Z"
      fill="url(#paint0_linear_1711_48264)"
    />
    <path
      d="M28.6391 68.3477H134.657L121.616 48.1696C120.182 45.9558 116.636 44.165 113.685 44.165H18.3394C15.3999 44.165 14.1635 45.9558 15.5982 48.1696L28.6391 68.3477Z"
      fill="#407BFF"
    />
    <path
      d="M28.6391 68.3477H134.657L121.616 48.1696C120.182 45.9558 116.636 44.165 113.685 44.165H18.3394C15.3999 44.165 14.1635 45.9558 15.5982 48.1696L28.6391 68.3477Z"
      fill="url(#paint1_linear_1711_48264)"
    />
    <path
      d="M88.5715 61.7598C88.774 62.1527 88.9798 62.5398 89.1889 62.9212L88.7489 63.1655L88.1267 61.9859L88.5715 61.7598Z"
      fill="#2F3155"
    />
    <path
      d="M70.9862 5.61571L70.5723 5.85472L70.8212 6.28594C71.579 5.82564 72.3636 5.41103 73.1709 5.04436L72.9679 4.58658C72.3147 4.90241 71.6359 5.2406 70.9862 5.61571ZM75.5247 3.62406L75.675 4.09689C76.5206 3.8345 77.3846 3.6355 78.2598 3.50153L78.1827 3.00942C77.2846 3.15203 76.3983 3.36133 75.5313 3.63556L75.5247 3.62406ZM80.9076 2.81613L80.9106 3.31268C81.7942 3.31699 82.6761 3.39238 83.5476 3.5381L83.6344 3.05102C82.7327 2.89461 81.8194 2.81412 80.9042 2.81037L80.9076 2.81613ZM86.2733 3.70466L86.1263 4.18047C86.9697 4.44969 87.7926 4.77903 88.5889 5.16594L88.8059 4.71863C87.9855 4.31558 87.1368 3.97286 86.2666 3.69317L86.2733 3.70466ZM91.1606 6.08832L90.8758 6.49805C91.6034 7.00128 92.2862 7.56635 92.9166 8.18699L93.2642 7.833C92.6141 7.18934 91.9092 6.60363 91.1573 6.08256L91.1606 6.08832ZM95.0316 9.92502L94.6203 10.2085C94.7996 10.519 95.0224 10.812 95.1983 11.1167C95.4429 11.5442 95.664 11.9847 95.8605 12.4363C95.4304 12.7247 95.0172 13.0375 94.6229 13.3732L94.9433 13.7555C95.5722 13.2234 96.2463 12.747 96.9578 12.3318L97.1073 12.2454L96.8583 11.8142L96.7031 11.9039L96.2718 12.1528C96.0776 11.71 95.8591 11.2782 95.6172 10.8595C95.4437 10.5457 95.2372 10.228 95.0283 9.91927L95.0316 9.92502ZM99.3874 10.7374L99.532 11.2135C100.373 10.9616 101.24 10.8107 102.117 10.7639L102.09 10.2658C101.173 10.3136 100.264 10.4699 99.3841 10.7316L99.3874 10.7374ZM92.693 15.3153C92.1043 16.0127 91.572 16.7558 91.1012 17.5376L91.5297 17.7885C91.9856 17.0323 92.5015 16.3141 93.0725 15.6406L92.693 15.3153ZM96.6627 15.0473C96.8255 15.9118 96.8913 16.7918 96.8589 17.6709L97.3539 17.6917C97.3925 16.775 97.3254 15.8568 97.1539 14.9553L96.6627 15.0473ZM104.834 10.4521L104.748 10.9391C105.615 11.0951 106.466 11.336 107.286 11.6583L107.464 11.1955C106.612 10.854 105.727 10.5992 104.824 10.4348L104.834 10.4521ZM89.9156 19.9853L89.8612 20.1701C89.5807 20.9986 89.4843 21.8784 89.5787 22.748L90.0742 22.6766C89.9882 21.8803 90.078 21.0749 90.3371 20.317L90.3923 20.1471L89.9156 19.9853ZM109.913 12.3572L109.675 12.7939C110.462 13.2285 111.231 13.697 111.947 14.1805L112.228 13.765C111.5 13.2733 110.719 12.7967 109.913 12.3572ZM96.4397 20.2511C96.208 21.0631 95.8902 21.848 95.4916 22.5924L95.4385 22.6997L95.8752 22.9382L95.934 22.8276C96.3414 22.053 96.6644 21.2368 96.8973 20.3932L96.4397 20.2511ZM91.3709 24.6571L91.1539 25.1044C91.5997 25.3082 92.0883 25.4009 92.5778 25.3747C93.0673 25.3484 93.5431 25.2039 93.9646 24.9536L93.7156 24.5223C93.3633 24.7285 92.9671 24.8482 92.5595 24.8717C92.1519 24.8951 91.7446 24.8216 91.3709 24.6571ZM114.394 15.4048L114.078 15.7867C114.761 16.3546 115.414 16.9577 116.034 17.5937L116.388 17.2512C115.762 16.5959 115.098 15.9783 114.4 15.4015L114.394 15.4048ZM118.176 19.3004L117.778 19.6068C118.321 20.3102 118.824 21.0437 119.284 21.8038L119.716 21.5548C119.245 20.7754 118.731 20.0227 118.176 19.3004ZM120.532 24.1501C120.908 24.9618 121.242 25.7927 121.532 26.6392L122.007 26.4798C121.713 25.623 121.375 24.7816 120.996 23.9587L120.532 24.1501ZM122.25 29.1839C122.45 30.0345 122.612 30.9141 122.732 31.8112L123.227 31.7398C123.105 30.837 122.949 29.9302 122.737 29.0714L122.25 29.1839ZM122.998 34.4633C123.041 35.3351 123.048 36.236 123.013 37.1453L123.511 37.1571C123.536 36.2454 123.529 35.3297 123.479 34.4463L122.998 34.4633ZM122.855 39.8051C122.77 40.6816 122.648 41.5724 122.499 42.4558L122.992 42.5393C123.144 41.6468 123.265 40.7412 123.351 39.8556L122.855 39.8051ZM121.976 45.081C121.784 45.958 121.541 46.8114 121.283 47.6657L121.759 47.8126C122.022 46.9402 122.275 46.0505 122.455 45.1949L121.976 45.081ZM120.436 50.2091C120.143 51.0298 119.796 51.8746 119.446 52.6898L119.898 52.8887C120.259 52.0669 120.598 51.2196 120.901 50.3775L120.436 50.2091Z"
      fill="#3B424F"
    />
    <path
      d="M68.2827 7.45264C67.9237 7.72401 67.5797 8.01475 67.2523 8.32355L67.5981 8.68354C67.5981 8.68354 67.9523 8.34104 68.5859 7.84494L68.2827 7.45264Z"
      fill="#3B424F"
    />
    <path
      d="M62.9757 11.6588C61.3777 9.51492 65.3315 5.51491 67.4275 8.32192C69.5234 11.1289 64.5837 13.8199 62.9757 11.6588Z"
      fill="#3B424F"
    />
    <path
      d="M66.9303 4.30048C65.992 3.68457 64.3757 4.45679 63.4213 6.49506C62.8142 7.95051 62.4908 9.50851 62.4683 11.0853C63.9013 10.4458 65.1987 9.53798 66.2906 8.41089C67.8138 6.68053 67.8981 4.91461 66.9303 4.30048Z"
      fill="#99A2DA"
    />
    <path
      d="M66.9303 4.30048C65.992 3.68457 64.3757 4.45679 63.4213 6.49506C62.8142 7.95051 62.4908 9.50851 62.4683 11.0853C63.9013 10.4458 65.1987 9.53798 66.2906 8.41089C67.8138 6.68053 67.8981 4.91461 66.9303 4.30048Z"
      fill="url(#paint2_linear_1711_48264)"
      fillOpacity="0.2"
    />
    <path
      d="M71.1652 9.88226C71.4887 10.9604 70.2889 12.2817 68.0662 12.6144C66.495 12.7796 64.9067 12.6427 63.3869 12.2111C64.421 11.0174 65.6746 10.0334 67.0798 9.31247C69.1103 8.35477 70.8308 8.77203 71.1652 9.88226Z"
      fill="#99A2DA"
    />
    <path
      d="M71.1652 9.88226C71.4887 10.9604 70.2889 12.2817 68.0662 12.6144C66.495 12.7796 64.9067 12.6427 63.3869 12.2111C64.421 11.0174 65.6746 10.0334 67.0798 9.31247C69.1103 8.35477 70.8308 8.77203 71.1652 9.88226Z"
      fill="#99A2DA"
    />
    <path
      d="M71.1652 9.88226C71.4887 10.9604 70.2889 12.2817 68.0662 12.6144C66.495 12.7796 64.9067 12.6427 63.3869 12.2111C64.421 11.0174 65.6746 10.0334 67.0798 9.31247C69.1103 8.35477 70.8308 8.77203 71.1652 9.88226Z"
      fill="url(#paint3_linear_1711_48264)"
      fillOpacity="0.2"
    />
    <path
      d="M62.9761 11.6585C63.1297 11.5442 63.2461 11.387 63.3105 11.2067C63.3749 11.0264 63.3844 10.8311 63.3379 10.6453C63.2914 10.4596 63.191 10.2918 63.0492 10.1631C62.9075 10.0344 62.7307 9.95052 62.5414 9.92212C62.352 9.89372 62.1585 9.92204 61.9853 10.0035C61.812 10.085 61.6667 10.2159 61.5678 10.3798C61.4688 10.5437 61.4206 10.7333 61.4293 10.9246C61.438 11.1158 61.5031 11.3003 61.6164 11.4546C61.7703 11.6611 61.9996 11.7984 62.2543 11.8366C62.5089 11.8748 62.7684 11.8108 62.9761 11.6585Z"
      fill="#3B424F"
    />
    <path
      d="M64.1374 13.2189C64.2399 13.1426 64.3263 13.0469 64.3918 12.9372C64.4572 12.8276 64.5004 12.7061 64.519 12.5797C64.5375 12.4533 64.5309 12.3246 64.4997 12.2007C64.4684 12.0769 64.4131 11.9604 64.3368 11.858C64.2605 11.7555 64.1648 11.6691 64.0552 11.6036C63.9455 11.5382 63.824 11.4949 63.6977 11.4764C63.5713 11.4579 63.4425 11.4645 63.3187 11.4957C63.1948 11.527 63.0784 11.5823 62.9759 11.6586C62.769 11.8126 62.6318 12.0425 62.5944 12.2977C62.557 12.5529 62.6225 12.8126 62.7765 13.0195C62.9305 13.2264 63.1605 13.3636 63.4157 13.401C63.6709 13.4384 63.9305 13.3729 64.1374 13.2189Z"
      fill="#3B424F"
    />
    <path
      d="M178.457 68.3476H72.4507L85.4915 55.1916C86.9263 53.7815 90.4722 52.583 93.4234 52.583H188.757C191.708 52.583 192.933 53.7533 191.498 55.1916L178.457 68.3476Z"
      fill="url(#paint4_linear_1711_48264)"
    />
    <path
      d="M72.4507 68.3477H178.457V161.849C178.457 163.047 178.262 164.234 177.883 165.341C177.503 166.447 176.948 167.453 176.247 168.3C175.546 169.148 174.714 169.82 173.798 170.278C172.883 170.737 171.901 170.972 170.91 170.972H79.9976C79.0065 170.972 78.0251 170.737 77.1095 170.278C76.1939 169.82 75.3619 169.148 74.6611 168.3C73.9603 167.453 73.4044 166.447 73.0252 165.341C72.6459 164.234 72.4507 163.047 72.4507 161.849V68.3477Z"
      fill="url(#paint5_linear_1711_48264)"
    />
    <path
      d="M178.567 116.144L178.457 161.849C178.457 163.047 178.262 164.234 177.883 165.34C177.503 166.447 176.948 167.453 176.247 168.3C175.546 169.147 174.714 169.819 173.798 170.278C172.883 170.736 171.901 170.972 170.91 170.972H79.9976C79.0065 170.972 78.0251 170.736 77.1095 170.278C76.1939 169.819 75.3619 169.147 74.6611 168.3C73.9603 167.453 73.4044 166.447 73.0252 165.34C72.6459 164.234 72.4507 163.047 72.4507 161.849V116.144L75.4925 121.62C98.7213 163.437 159.9 160.186 178.567 116.144Z"
      fill="#5B56C6"
    />
    <g filter="url(#filter0_d_1711_48264)">
      <path
        d="M41.5566 68.1699L43.1406 85.0003L45.3091 88.2567L47.9501 89.4152L50.2446 88.1259L52.5989 89.4152L55.8733 88.4482L59.4823 89.4152V68.1699H41.5566Z"
        fill="#E2E3F5"
      />
    </g>
    <g filter="url(#filter1_d_1711_48264)">
      <path
        d="M80.876 43.6298L84.1745 49.313L83.7535 51.8206L82.5402 53.1429L80.9133 52.8757L79.8957 54.2127L77.7918 54.3698L75.98 55.7968L70.6788 43.6298L80.876 43.6298Z"
        fill="#E2E3F5"
      />
    </g>
    <path
      d="M41.5566 68.1699L42.6406 86.5003L45.3091 88.2567L47.9501 89.4152L50.2446 88.1259L52.5989 89.4152L55.8733 88.4482L59.4823 89.4152L55.1022 87.7966C48.4571 85.3411 43.6068 79.5534 42.3511 72.5813L41.5566 68.1699Z"
      fill="#F0F2FA"
    />
    <g filter="url(#filter2_dd_1711_48264)">
      <path
        d="M160.764 54.9434L159.623 52.5H171.141C170.252 55.0919 175.955 60.6016 179.392 63.6953C182.83 66.7891 185.58 70.5703 181.799 73.6641C178.017 76.7578 174.233 74.0078 172.517 72.2891C170.802 70.5703 168.915 68.5972 167.478 67.1569C164.384 64.0631 160.624 66.1256 159.139 62.3272C158.327 60.2544 159.493 58.1025 160.235 56.975C160.632 56.3752 160.818 55.6606 160.764 54.9434Z"
        fill="white"
      />
    </g>
    <path
      d="M160.751 55.5342C160.696 56.0485 160.519 56.5422 160.235 56.9745C159.493 58.102 158.327 60.2539 159.139 62.3267C160.404 65.5682 163.353 64.5439 166.103 66.0942C167.32 61.0892 165.072 56.9332 160.751 55.5342ZM174.92 74.1345C176.818 75.2001 179.306 75.6986 181.795 73.6636C184.098 71.7764 183.971 69.6348 182.747 67.5482C179.076 67.8439 176.123 70.6145 174.92 74.1345Z"
      fill="#EAEAEA"
    />
    <path
      d="M127.83 185.271C128 185.271 128 185.271 128.171 185.271C128 185.271 127.66 185.442 127.49 185.442C127.49 185.271 127.66 185.271 127.83 185.271Z"
      fill="#D5DAE8"
    />
    <path
      d="M128.341 185.102C128.511 185.102 128.511 185.102 128.681 184.932C128.511 184.932 128.171 185.102 128 185.102C128.171 185.102 128.171 185.102 128.341 185.102Z"
      fill="#D5DAE8"
    />
    <g filter="url(#filter3_i_1711_48264)">
      <path
        d="M145.745 183.103C165.519 183.103 181.55 167.073 181.55 147.299C181.55 127.524 165.519 111.494 145.745 111.494C125.971 111.494 109.94 127.524 109.94 147.299C109.94 167.073 125.971 183.103 145.745 183.103Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter4_i_1711_48264)">
      <path
        d="M143.425 131.932C143.197 129.556 145.066 127.5 147.453 127.5C149.84 127.5 151.708 129.556 151.48 131.932L149.729 150.169C149.617 151.342 148.631 152.237 147.453 152.237C146.274 152.237 145.289 151.342 145.176 150.169L143.425 131.932Z"
        fill="url(#paint6_linear_1711_48264)"
      />
    </g>
    <g filter="url(#filter5_i_1711_48264)">
      <ellipse
        cx="147.453"
        cy="160.152"
        rx="4.45265"
        ry="3.95791"
        fill="url(#paint7_linear_1711_48264)"
      />
    </g>
    <g filter="url(#filter6_i_1711_48264)">
      <path
        d="M194.339 200.703C192.949 200.703 191.56 200.147 190.448 198.897L172.238 180.687L171.404 181.243C163.9 186.802 155.144 189.721 146.249 189.721C135.548 189.721 124.847 185.413 116.925 177.908C108.586 169.986 104 159.285 104 147.61C104 124.401 122.901 105.5 146.11 105.5C161.954 105.5 175.852 113.839 183.357 128.014C190.722 142.051 189.75 158.451 180.716 171.654L180.16 172.488L198.508 190.836C200.871 193.199 200.315 195.561 199.898 196.812C198.786 199.036 196.563 200.703 194.339 200.703ZM146.11 117.035C129.155 117.035 115.535 130.794 115.535 147.61C115.535 166.789 131.24 178.325 146.527 178.325C155.839 178.325 164.317 174.155 170.293 166.65C177.659 157.478 178.909 145.109 173.767 134.407C168.486 123.706 157.924 117.035 146.11 117.035Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1711_48264"
        x="25.5566"
        y="65.1699"
        width="35.9258"
        height="39.2452"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-7" dy="6" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1711_48264"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1711_48264"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_1711_48264"
        x="67.6787"
        y="42.6298"
        width="17.4958"
        height="16.167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1711_48264"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1711_48264"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_1711_48264"
        x="145.863"
        y="41.5"
        width="42.7573"
        height="41.5648"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="-2" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1711_48264"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.183333 0 0 0 0 0.180278 0 0 0 0 0.180278 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1711_48264"
          result="effect2_dropShadow_1711_48264"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1711_48264"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_i_1711_48264"
        x="109.94"
        y="107.494"
        width="75.6094"
        height="75.6093"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_48264"
        />
      </filter>
      <filter
        id="filter4_i_1711_48264"
        x="143.407"
        y="125.5"
        width="11.092"
        height="26.7369"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_48264"
        />
      </filter>
      <filter
        id="filter5_i_1711_48264"
        x="143"
        y="154.194"
        width="11.9053"
        height="9.91583"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_48264"
        />
      </filter>
      <filter
        id="filter6_i_1711_48264"
        x="104"
        y="102.5"
        width="99.2708"
        height="98.2034"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" dy="-4" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1711_48264"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1711_48264"
        x1="41.1406"
        y1="153"
        x2="46.6406"
        y2="-45.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1711_48264"
        x1="74.6406"
        y1="155"
        x2="75.1948"
        y2="19.4939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1711_48264"
        x1="65.3519"
        y1="9.36368"
        x2="68.5424"
        y2="5.7641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1711_48264"
        x1="68.0001"
        y1="13"
        x2="71.0001"
        y2="9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1711_48264"
        x1="132.641"
        y1="77"
        x2="132.495"
        y2="36.5005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1711_48264"
        x1="125.778"
        y1="171.965"
        x2="125.778"
        y2="-36.3501"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_1711_48264"
        x1="147.453"
        y1="127.5"
        x2="162.06"
        y2="138.474"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_1711_48264"
        x1="147.453"
        y1="156.194"
        x2="150.962"
        y2="164.433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoOrder = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
  >
    <rect width="200" height="200" rx="100" fill="#F0F2FA" />
    <path
      d="M181.54 159.08C183.495 159.08 185.08 157.495 185.08 155.54C185.08 153.585 183.495 152 181.54 152C179.585 152 178 153.585 178 155.54C178 157.495 179.585 159.08 181.54 159.08Z"
      fill="white"
    />
    <path
      d="M180.035 22.0526C181.774 22.0526 183.185 20.6423 183.185 18.9026C183.185 17.1629 181.774 15.7526 180.035 15.7526C178.295 15.7526 176.885 17.1629 176.885 18.9026C176.885 20.6423 178.295 22.0526 180.035 22.0526Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 35.7526C171.751 35.7526 174.885 32.6186 174.885 28.7526C174.885 24.8866 171.751 21.7526 167.885 21.7526C164.019 21.7526 160.885 24.8866 160.885 28.7526C160.885 32.6186 164.019 35.7526 167.885 35.7526Z"
      fill="white"
    />
    <path
      d="M37.8848 185.753C41.7507 185.753 44.8848 182.619 44.8848 178.753C44.8848 174.887 41.7507 171.753 37.8848 171.753C34.0188 171.753 30.8848 174.887 30.8848 178.753C30.8848 182.619 34.0188 185.753 37.8848 185.753Z"
      fill="white"
    />
    <path
      d="M191.885 157C192.989 157 193.885 156.105 193.885 155C193.885 153.895 192.989 153 191.885 153C190.78 153 189.885 153.895 189.885 155C189.885 156.105 190.78 157 191.885 157Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.301C38.3573 30.301 40.6633 27.995 40.6633 25.1505C40.6633 22.306 38.3573 20 35.5128 20C32.6683 20 30.3623 22.306 30.3623 25.1505C30.3623 27.995 32.6683 30.301 35.5128 30.301Z"
      fill="white"
    />
    <path
      d="M19.0123 30.3C20.4759 30.3 21.6623 29.1136 21.6623 27.65C21.6623 26.1864 20.4759 25 19.0123 25C17.5487 25 16.3623 26.1864 16.3623 27.65C16.3623 29.1136 17.5487 30.3 19.0123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195C36.0475 195 37.3906 193.657 37.3906 192C37.3906 190.343 36.0475 189 34.3906 189C32.7338 189 31.3906 190.343 31.3906 192C31.3906 193.657 32.7338 195 34.3906 195Z"
      fill="#C5B8EA"
    />
    <path
      d="M28.6392 67.8477H178.457V161.349C178.457 162.547 178.262 163.734 177.883 164.841C177.504 165.947 176.948 166.953 176.247 167.8C175.546 168.648 174.714 169.32 173.798 169.778C172.883 170.237 171.901 170.472 170.91 170.472H36.1861C35.195 170.472 34.2136 170.237 33.298 169.778C32.3823 169.32 31.5504 168.648 30.8496 167.8C30.1488 166.953 29.5929 165.947 29.2136 164.841C28.8344 163.734 28.6392 162.547 28.6392 161.349V67.8477Z"
      fill="url(#paint0_linear_231_52644)"
    />
    <path
      d="M28.6391 67.8477H134.657L121.616 47.6696C120.182 45.4558 116.636 43.665 113.685 43.665H18.3394C15.3999 43.665 14.1635 45.4558 15.5982 47.6696L28.6391 67.8477Z"
      fill="#407BFF"
    />
    <path
      d="M28.6391 67.8477H134.657L121.616 47.6696C120.182 45.4558 116.636 43.665 113.685 43.665H18.3394C15.3999 43.665 14.1635 45.4558 15.5982 47.6696L28.6391 67.8477Z"
      fill="url(#paint1_linear_231_52644)"
    />
    <path
      d="M88.5715 61.2598C88.774 61.6527 88.9798 62.0398 89.1889 62.4212L88.7489 62.6655L88.1267 61.4859L88.5715 61.2598Z"
      fill="#2F3155"
    />
    <path
      d="M70.9861 5.11571L70.5721 5.35472L70.8211 5.78594C71.5789 5.32564 72.3635 4.91103 73.1708 4.54436L72.9678 4.08658C72.3145 4.40241 71.6358 4.7406 70.9861 5.11571ZM75.5246 3.12406L75.6749 3.59689C76.5205 3.3345 77.3845 3.1355 78.2597 3.00153L78.1825 2.50942C77.2844 2.65203 76.3982 2.86133 75.5312 3.13556L75.5246 3.12406ZM80.9074 2.31613L80.9105 2.81268C81.7941 2.81699 82.6759 2.89238 83.5475 3.0381L83.6342 2.55102C82.7325 2.39461 81.8193 2.31412 80.9041 2.31037L80.9074 2.31613ZM86.2731 3.20466L86.1262 3.68047C86.9696 3.94969 87.7925 4.27903 88.5887 4.66594L88.8058 4.21863C87.9854 3.81558 87.1367 3.47286 86.2665 3.19317L86.2731 3.20466ZM91.1605 5.58832L90.8757 5.99805C91.6033 6.50128 92.2861 7.06635 92.9165 7.68699L93.264 7.333C92.614 6.68934 91.909 6.10363 91.1572 5.58256L91.1605 5.58832ZM95.0315 9.42502L94.6202 9.70849C94.7995 10.019 95.0223 10.312 95.1982 10.6167C95.4428 11.0442 95.6639 11.4847 95.8604 11.9363C95.4303 12.2247 95.0171 12.5375 94.6228 12.8732L94.9432 13.2555C95.5721 12.7234 96.2462 12.247 96.9577 11.8318L97.1072 11.7454L96.8582 11.3142L96.7029 11.4039L96.2717 11.6528C96.0775 11.21 95.8589 10.7782 95.6171 10.3595C95.4436 10.0457 95.2371 9.72798 95.0282 9.41927L95.0315 9.42502ZM99.3873 10.2374L99.5319 10.7135C100.373 10.4616 101.24 10.3107 102.116 10.2639L102.09 9.76582C101.172 9.81355 100.264 9.96991 99.384 10.2316L99.3873 10.2374ZM92.6929 14.8153C92.1042 15.5127 91.5719 16.2558 91.1011 17.0376L91.5296 17.2885C91.9855 16.5323 92.5014 15.8141 93.0723 15.1406L92.6929 14.8153ZM96.6626 14.5473C96.8254 15.4118 96.8912 16.2918 96.8587 17.1709L97.3538 17.1917C97.3924 16.275 97.3253 15.3568 97.1538 14.4553L96.6626 14.5473ZM104.834 9.95206L104.747 10.4391C105.615 10.5951 106.466 10.836 107.286 11.1583L107.464 10.6955C106.612 10.354 105.727 10.0992 104.824 9.93481L104.834 9.95206ZM89.9155 19.4853L89.8611 19.6701C89.5806 20.4986 89.4842 21.3784 89.5786 22.248L90.0741 22.1766C89.9881 21.3803 90.0778 20.5749 90.3369 19.817L90.3922 19.6471L89.9155 19.4853ZM109.913 11.8572L109.674 12.2939C110.462 12.7285 111.231 13.197 111.947 13.6805L112.228 13.265C111.5 12.7733 110.719 12.2967 109.913 11.8572ZM96.4395 19.7511C96.2079 20.5631 95.8901 21.348 95.4914 22.0924L95.4384 22.1997L95.8751 22.4382L95.9339 22.3276C96.3413 21.553 96.6642 20.7368 96.8972 19.8932L96.4395 19.7511ZM91.3708 24.1571L91.1537 24.6044C91.5996 24.8082 92.0882 24.9009 92.5777 24.8747C93.0672 24.8484 93.543 24.7039 93.9645 24.4536L93.7155 24.0223C93.3632 24.2285 92.9669 24.3482 92.5594 24.3717C92.1518 24.3951 91.7445 24.3216 91.3708 24.1571ZM114.394 14.9048L114.078 15.2867C114.761 15.8546 115.413 16.4577 116.033 17.0937L116.388 16.7512C115.762 16.0959 115.098 15.4783 114.4 14.9015L114.394 14.9048ZM118.176 18.8004L117.778 19.1068C118.321 19.8102 118.824 20.5437 119.284 21.3038L119.716 21.0548C119.245 20.2754 118.731 19.5227 118.176 18.8004ZM120.532 23.6501C120.908 24.4618 121.242 25.2927 121.532 26.1392L122.007 25.9798C121.713 25.123 121.375 24.2816 120.996 23.4587L120.532 23.6501ZM122.25 28.6839C122.449 29.5345 122.612 30.4141 122.732 31.3112L123.227 31.2398C123.104 30.337 122.949 29.4302 122.737 28.5714L122.25 28.6839ZM122.998 33.9633C123.041 34.8351 123.048 35.736 123.013 36.6453L123.511 36.6571C123.536 35.7454 123.529 34.8297 123.479 33.9463L122.998 33.9633ZM122.854 39.3051C122.77 40.1816 122.648 41.0724 122.499 41.9558L122.992 42.0393C123.143 41.1468 123.265 40.2412 123.351 39.3556L122.854 39.3051ZM121.975 44.581C121.784 45.458 121.541 46.3114 121.283 47.1657L121.759 47.3126C122.022 46.4402 122.275 45.5505 122.455 44.6949L121.975 44.581ZM120.436 49.7091C120.143 50.5298 119.795 51.3746 119.446 52.1898L119.898 52.3887C120.259 51.5669 120.598 50.7196 120.901 49.8775L120.436 49.7091Z"
      fill="#3B424F"
    />
    <path
      d="M68.2828 6.95264C67.9238 7.22401 67.5798 7.51475 67.2524 7.82355L67.5982 8.18354C67.5982 8.18354 67.9525 7.84104 68.586 7.34494L68.2828 6.95264Z"
      fill="#3B424F"
    />
    <path
      d="M62.9758 11.1588C61.3778 9.01492 65.3317 5.01491 67.4276 7.82192C69.5235 10.6289 64.5839 13.3199 62.9758 11.1588Z"
      fill="#3B424F"
    />
    <path
      d="M66.9304 3.80048C65.9922 3.18457 64.3758 3.95679 63.4214 5.99506C62.8143 7.45051 62.4909 9.00851 62.4685 10.5853C63.9015 9.94578 65.1989 9.03798 66.2907 7.91089C67.8139 6.18053 67.8983 4.41461 66.9304 3.80048Z"
      fill="#99A2DA"
    />
    <path
      d="M66.9304 3.80048C65.9922 3.18457 64.3758 3.95679 63.4214 5.99506C62.8143 7.45051 62.4909 9.00851 62.4685 10.5853C63.9015 9.94578 65.1989 9.03798 66.2907 7.91089C67.8139 6.18053 67.8983 4.41461 66.9304 3.80048Z"
      fill="url(#paint2_linear_231_52644)"
      fillOpacity="0.2"
    />
    <path
      d="M71.1651 9.38226C71.4885 10.4604 70.2888 11.7817 68.0661 12.1144C66.4949 12.2796 64.9066 12.1427 63.3868 11.7111C64.4209 10.5174 65.6745 9.53339 67.0796 8.81247C69.1102 7.85477 70.8307 8.27203 71.1651 9.38226Z"
      fill="#99A2DA"
    />
    <path
      d="M71.1651 9.38226C71.4885 10.4604 70.2888 11.7817 68.0661 12.1144C66.4949 12.2796 64.9066 12.1427 63.3868 11.7111C64.4209 10.5174 65.6745 9.53339 67.0796 8.81247C69.1102 7.85477 70.8307 8.27203 71.1651 9.38226Z"
      fill="#99A2DA"
    />
    <path
      d="M71.1651 9.38226C71.4885 10.4604 70.2888 11.7817 68.0661 12.1144C66.4949 12.2796 64.9066 12.1427 63.3868 11.7111C64.4209 10.5174 65.6745 9.53339 67.0796 8.81247C69.1102 7.85477 70.8307 8.27203 71.1651 9.38226Z"
      fill="url(#paint3_linear_231_52644)"
      fillOpacity="0.2"
    />
    <path
      d="M62.976 11.1585C63.1296 11.0442 63.246 10.887 63.3104 10.7067C63.3747 10.5264 63.3843 10.3311 63.3378 10.1453C63.2913 9.95958 63.1908 9.79178 63.0491 9.66308C62.9073 9.53437 62.7306 9.45052 62.5413 9.42212C62.3519 9.39372 62.1584 9.42204 61.9851 9.5035C61.8119 9.58495 61.6666 9.71589 61.5676 9.87981C61.4687 10.0437 61.4205 10.2333 61.4292 10.4246C61.4378 10.6158 61.5029 10.8003 61.6163 10.9546C61.7702 11.1611 61.9994 11.2984 62.2541 11.3366C62.5088 11.3748 62.7683 11.3108 62.976 11.1585Z"
      fill="#3B424F"
    />
    <path
      d="M64.1375 12.7189C64.24 12.6426 64.3264 12.5469 64.3919 12.4372C64.4573 12.3276 64.5006 12.2061 64.5191 12.0797C64.5376 11.9533 64.531 11.8246 64.4998 11.7007C64.4685 11.5769 64.4132 11.4604 64.3369 11.358C64.2607 11.2555 64.165 11.1691 64.0553 11.1036C63.9456 11.0382 63.8242 10.9949 63.6978 10.9764C63.5714 10.9579 63.4426 10.9645 63.3188 10.9957C63.195 11.027 63.0785 11.0823 62.976 11.1586C62.7691 11.3126 62.6319 11.5425 62.5945 11.7977C62.5571 12.0529 62.6226 12.3126 62.7766 12.5195C62.9307 12.7264 63.1606 12.8636 63.4158 12.901C63.671 12.9384 63.9306 12.8729 64.1375 12.7189Z"
      fill="#3B424F"
    />
    <path
      d="M178.457 67.8476H72.4507L85.4915 54.6916C86.9263 53.2815 90.4722 52.083 93.4234 52.083H188.757C191.708 52.083 192.933 53.2533 191.498 54.6916L178.457 67.8476Z"
      fill="url(#paint4_linear_231_52644)"
    />
    <path
      d="M72.4507 67.8477H178.457V161.349C178.457 162.547 178.262 163.734 177.883 164.841C177.503 165.947 176.948 166.953 176.247 167.8C175.546 168.648 174.714 169.32 173.798 169.778C172.883 170.237 171.901 170.472 170.91 170.472H79.9976C79.0065 170.472 78.0251 170.237 77.1095 169.778C76.1939 169.32 75.3619 168.648 74.6611 167.8C73.9603 166.953 73.4044 165.947 73.0252 164.841C72.6459 163.734 72.4507 162.547 72.4507 161.349V67.8477Z"
      fill="url(#paint5_linear_231_52644)"
    />
    <path
      d="M178.567 115.644L178.457 161.349C178.457 162.547 178.262 163.734 177.883 164.84C177.503 165.947 176.948 166.953 176.247 167.8C175.546 168.647 174.714 169.319 173.798 169.778C172.883 170.236 171.901 170.472 170.91 170.472H79.9976C79.0065 170.472 78.0251 170.236 77.1095 169.778C76.1939 169.319 75.3619 168.647 74.6611 167.8C73.9603 166.953 73.4044 165.947 73.0252 164.84C72.6459 163.734 72.4507 162.547 72.4507 161.349V115.644L75.4925 121.12C98.7213 162.937 159.9 159.686 178.567 115.644Z"
      fill="#5B56C6"
    />
    <g filter="url(#filter0_d_231_52644)">
      <path
        d="M41.5566 67.6699L43.1406 84.5003L45.3091 87.7567L47.9501 88.9152L50.2446 87.6259L52.5989 88.9152L55.8733 87.9482L59.4823 88.9152V67.6699H41.5566Z"
        fill="#E2E3F5"
      />
    </g>
    <g filter="url(#filter1_d_231_52644)">
      <path
        d="M80.876 43.1298L84.1745 48.813L83.7535 51.3206L82.5402 52.6429L80.9133 52.3757L79.8957 53.7127L77.7918 53.8698L75.98 55.2968L70.6788 43.1298L80.876 43.1298Z"
        fill="#E2E3F5"
      />
    </g>
    <path
      d="M41.5566 67.6699L42.6406 86.0003L45.3091 87.7567L47.9501 88.9152L50.2446 87.6259L52.5989 88.9152L55.8733 87.9482L59.4823 88.9152L55.1022 87.2966C48.4571 84.8411 43.6068 79.0534 42.3511 72.0813L41.5566 67.6699Z"
      fill="#F0F2FA"
    />
    <g filter="url(#filter2_dd_231_52644)">
      <path
        d="M160.764 54.4434L159.623 52H171.141C170.252 54.5919 175.955 60.1016 179.392 63.1953C182.83 66.2891 185.58 70.0703 181.799 73.1641C178.017 76.2578 174.233 73.5078 172.517 71.7891C170.802 70.0703 168.915 68.0972 167.478 66.6569C164.384 63.5631 160.624 65.6256 159.139 61.8272C158.327 59.7544 159.493 57.6025 160.235 56.475C160.632 55.8752 160.818 55.1606 160.764 54.4434Z"
        fill="white"
      />
    </g>
    <path
      d="M160.751 55.0342C160.696 55.5485 160.519 56.0422 160.235 56.4745C159.493 57.602 158.327 59.7539 159.139 61.8267C160.404 65.0682 163.353 64.0439 166.103 65.5942C167.32 60.5892 165.072 56.4332 160.751 55.0342ZM174.92 73.6345C176.818 74.7001 179.306 75.1986 181.795 73.1636C184.098 71.2764 183.971 69.1348 182.747 67.0482C179.076 67.3439 176.123 70.1145 174.92 73.6345Z"
      fill="#EAEAEA"
    />
    <path
      d="M127.83 184.771C128 184.771 128 184.771 128.171 184.771C128 184.771 127.66 184.942 127.49 184.942C127.49 184.771 127.66 184.771 127.83 184.771Z"
      fill="#D5DAE8"
    />
    <path
      d="M128.341 184.602C128.511 184.602 128.511 184.602 128.681 184.432C128.511 184.432 128.171 184.602 128 184.602C128.171 184.602 128.171 184.602 128.341 184.602Z"
      fill="#D5DAE8"
    />
    <defs>
      <filter
        id="filter0_d_231_52644"
        x="25.5566"
        y="64.6699"
        width="35.9257"
        height="39.2452"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-7" dy="6" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_231_52644"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_231_52644"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_231_52644"
        x="67.6787"
        y="42.1298"
        width="17.4958"
        height="16.167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1" dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_231_52644"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_231_52644"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_231_52644"
        x="145.863"
        y="41"
        width="42.7573"
        height="41.5648"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="-2" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0 0.679167 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_231_52644"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.183333 0 0 0 0 0.180278 0 0 0 0 0.180278 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_231_52644"
          result="effect2_dropShadow_231_52644"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_231_52644"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_231_52644"
        x1="41.1406"
        y1="152.5"
        x2="46.6406"
        y2="-46"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_231_52644"
        x1="74.6406"
        y1="154.5"
        x2="75.1948"
        y2="18.9939"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_231_52644"
        x1="65.352"
        y1="8.86368"
        x2="68.5426"
        y2="5.2641"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_231_52644"
        x1="68"
        y1="12.5"
        x2="71"
        y2="8.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_231_52644"
        x1="132.641"
        y1="76.5"
        x2="132.495"
        y2="36.0005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_231_52644"
        x1="125.778"
        y1="171.465"
        x2="125.778"
        y2="-36.8501"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const NoNotification = (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" rx="100" fill="#F0F2FA" />
    <path
      d="M181.54 159.08C183.495 159.08 185.08 157.495 185.08 155.54C185.08 153.585 183.495 152 181.54 152C179.585 152 178 153.585 178 155.54C178 157.495 179.585 159.08 181.54 159.08Z"
      fill="white"
    />
    <path
      d="M180.035 22.0524C181.774 22.0524 183.185 20.6421 183.185 18.9024C183.185 17.1627 181.774 15.7524 180.035 15.7524C178.295 15.7524 176.885 17.1627 176.885 18.9024C176.885 20.6421 178.295 22.0524 180.035 22.0524Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 35.7524C171.751 35.7524 174.885 32.6184 174.885 28.7524C174.885 24.8864 171.751 21.7524 167.885 21.7524C164.019 21.7524 160.885 24.8864 160.885 28.7524C160.885 32.6184 164.019 35.7524 167.885 35.7524Z"
      fill="white"
    />
    <path
      d="M37.8848 185.752C41.7507 185.752 44.8848 182.618 44.8848 178.752C44.8848 174.886 41.7507 171.752 37.8848 171.752C34.0188 171.752 30.8848 174.886 30.8848 178.752C30.8848 182.618 34.0188 185.752 37.8848 185.752Z"
      fill="white"
    />
    <path
      d="M192.885 161C193.989 161 194.885 160.104 194.885 159C194.885 157.895 193.989 157 192.885 157C191.78 157 190.885 157.895 190.885 159C190.885 160.104 191.78 161 192.885 161Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.301C38.3573 30.301 40.6633 27.995 40.6633 25.1505C40.6633 22.306 38.3573 20 35.5128 20C32.6683 20 30.3623 22.306 30.3623 25.1505C30.3623 27.995 32.6683 30.301 35.5128 30.301Z"
      fill="white"
    />
    <path
      d="M19.0123 30.3C20.4759 30.3 21.6623 29.1136 21.6623 27.65C21.6623 26.1864 20.4759 25 19.0123 25C17.5487 25 16.3623 26.1864 16.3623 27.65C16.3623 29.1136 17.5487 30.3 19.0123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195C36.0475 195 37.3906 193.657 37.3906 192C37.3906 190.343 36.0475 189 34.3906 189C32.7338 189 31.3906 190.343 31.3906 192C31.3906 193.657 32.7338 195 34.3906 195Z"
      fill="#C5B8EA"
    />
    <g filter="url(#filter0_i_1344_38190)">
      <path
        d="M110.48 137H90.5197C85.8947 137 82 141.211 82 146.211V157C82 168.053 90.2763 177 100.5 177C110.724 177 119 168.053 119 157V146.211C119 140.947 115.105 137 110.48 137Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter1_i_1344_38190)">
      <path
        d="M108.541 45.3722H89.1631V35.6861C89.1631 30.2524 93.4168 26 98.8521 26C104.287 26 108.541 30.2524 108.541 35.6861V45.3722Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter2_i_1344_38190)">
      <path
        d="M141.283 83.4499V78.0164C141.283 54.3925 124.141 35.2571 100.51 35.2571C76.879 35.2571 59.7378 54.3925 59.7378 78.0164V83.4499C59.7378 108.986 48.3323 129.608 38.2313 142.864C33.6724 148.847 37.9216 159.283 45.4435 159.283H155.452C162.962 159.283 167.212 148.885 162.678 142.9C152.635 129.645 141.283 109.009 141.283 83.4499Z"
        fill="url(#paint0_linear_1344_38190)"
      />
    </g>
    <g filter="url(#filter3_i_1344_38190)">
      <path
        d="M169.216 32.0175C167.83 32.0175 166.707 30.8943 166.707 29.5088C166.707 28.1232 167.83 27 169.216 27H183.068C185.092 27 186.732 28.6403 186.732 30.6637C186.732 31.5374 186.42 32.3823 185.852 33.0461L173.068 47.9825H184.459C185.845 47.9825 186.968 49.1057 186.968 50.4912C186.968 51.8768 185.845 53 184.459 53H169.664C167.64 53 166 51.3597 166 49.3363C166 48.4626 166.312 47.6177 166.88 46.9539L179.664 32.0175H169.216Z"
        fill="url(#paint1_linear_1344_38190)"
      />
    </g>
    <g filter="url(#filter4_i_1344_38190)">
      <path
        d="M149.47 60.8356C148.41 60.8356 147.552 59.977 147.552 58.9178C147.552 57.8586 148.41 57 149.47 57H159.904C161.462 57 162.724 58.2625 162.724 59.8198C162.724 60.4764 162.495 61.1123 162.076 61.6181L152.517 73.1644H161.082C162.141 73.1644 163 74.023 163 75.0822C163 76.1414 162.141 77 161.082 77H149.82C148.262 77 147 75.7375 147 74.1802C147 73.5236 147.229 72.8877 147.648 72.3819L157.207 60.8356H149.47Z"
        fill="url(#paint2_linear_1344_38190)"
      />
    </g>
    <g filter="url(#filter5_i_1344_38190)">
      <path
        d="M126.373 86.0685C125.526 86.0685 124.839 85.3816 124.839 84.5342C124.839 83.6869 125.526 83 126.373 83H134.918C136.16 83 137.166 84.0068 137.166 85.2487C137.166 85.7782 136.98 86.2907 136.639 86.6959L128.873 95.9315H135.856C136.704 95.9315 137.391 96.6184 137.391 97.4658C137.391 98.3131 136.704 99 135.856 99H126.639C125.397 99 124.391 97.9932 124.391 96.7513C124.391 96.2218 124.577 95.7093 124.918 95.3041L132.684 86.0685H126.373Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1344_38190"
        x="82"
        y="132"
        width="42"
        height="45"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <filter
        id="filter1_i_1344_38190"
        x="89.1631"
        y="21"
        width="24.3779"
        height="24.3721"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <filter
        id="filter2_i_1344_38190"
        x="36.3516"
        y="22.2571"
        width="158.19"
        height="137.026"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="30" dy="-13" />
        <feGaussianBlur stdDeviation="15" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <filter
        id="filter3_i_1344_38190"
        x="166"
        y="27"
        width="22.9678"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <filter
        id="filter4_i_1344_38190"
        x="147"
        y="57"
        width="18"
        height="20"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <filter
        id="filter5_i_1344_38190"
        x="124.391"
        y="83"
        width="15"
        height="16"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.4 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1344_38190"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1344_38190"
        x1="100.392"
        y1="35.2571"
        x2="151.422"
        y2="168.166"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1344_38190"
        x1="176.484"
        y1="27"
        x2="190.523"
        y2="50.6281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1344_38190"
        x1="155"
        y1="57"
        x2="165.841"
        y2="75.099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const Nonetwork = (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="200" height="200" rx="100" fill="#F0F2FA" />
    <g filter="url(#filter0_i_1400_37150)">
      <path
        d="M100.297 170.524C139.121 170.524 170.594 139.066 170.594 100.262C170.594 61.4573 139.121 30 100.297 30C61.473 30 30 61.4573 30 100.262C30 139.066 61.473 170.524 100.297 170.524Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter1_i_1400_37150)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.6994 60.4139C81.6446 61.5132 73.5813 63.9114 65.2044 67.9968C58.1725 71.4263 49.1189 77.785 47.6253 80.3437C46.7077 81.9159 46.8106 84.3184 47.8642 85.9111C48.8872 87.4579 50.7957 88.4641 52.7067 88.4641C54.4469 88.4641 54.9264 88.2218 57.9271 85.8248C82.4627 66.2258 117.474 66.2258 142.01 85.8248C145.009 88.2202 145.418 88.4261 147.209 88.4397C150.397 88.4644 152.868 86.1278 152.912 83.0454C152.928 81.9323 152.737 81.0726 152.312 80.3437C150.816 77.7822 141.753 71.4182 134.733 68.0005C126.071 63.7837 118.356 61.5128 108.931 60.4062C104.29 59.8615 95.2193 59.8652 90.6994 60.4139ZM95.6429 82.4059C95.2181 82.4674 93.6192 82.672 92.0897 82.8609C83.3056 83.9456 72.7999 88.3083 66.063 93.6689C63.6889 95.558 63.231 96.2378 62.9962 98.2199C62.6455 101.184 64.7141 103.857 67.7262 104.334C69.5087 104.615 70.6501 104.153 73.8603 101.849C77.1573 99.4827 81.7651 97.1302 85.6075 95.852C99.3268 91.2868 114.492 93.5341 126.077 101.849C127.606 102.947 129.326 104.001 129.898 104.192C133.51 105.398 137.4 102.099 136.941 98.2199C136.706 96.2378 136.248 95.558 133.874 93.6689C128.12 89.0901 119.159 85.0155 111.417 83.4581C106.167 82.4018 98.986 81.923 95.6429 82.4059ZM93.1174 105.385C86.7043 106.739 80.4912 110.051 79.3816 112.708C78.1198 115.729 79.9573 119.401 83.131 120.201C84.7949 120.62 86.1312 120.386 87.9186 119.361C92.1046 116.96 95.7736 115.909 99.9686 115.909C104.163 115.909 107.833 116.96 112.019 119.361C113.806 120.386 115.142 120.62 116.806 120.201C119.879 119.427 121.762 115.855 120.65 112.911C119.595 110.116 113.347 106.737 106.746 105.39C102.819 104.59 96.8974 104.588 93.1174 105.385ZM96.9916 127.662C95.4684 128.131 93.1319 129.845 92.0255 131.305C89.1644 135.078 89.5719 140.744 92.9471 144.121C96.7843 147.96 103.153 147.96 106.99 144.121C108.99 142.12 109.701 140.313 109.701 137.235C109.701 134.987 109.577 134.354 108.842 132.857C107.891 130.92 106.249 129.272 104.231 128.23C102.735 127.458 98.6829 127.14 96.9916 127.662Z"
        fill="url(#paint0_linear_1400_37150)"
      />
    </g>
    <path
      d="M181.54 159.08C183.495 159.08 185.08 157.495 185.08 155.54C185.08 153.585 183.495 152 181.54 152C179.585 152 178 153.585 178 155.54C178 157.495 179.585 159.08 181.54 159.08Z"
      fill="white"
    />
    <path
      d="M180.035 22.0526C181.774 22.0526 183.185 20.6423 183.185 18.9026C183.185 17.1629 181.774 15.7526 180.035 15.7526C178.295 15.7526 176.885 17.1629 176.885 18.9026C176.885 20.6423 178.295 22.0526 180.035 22.0526Z"
      fill="#C5B8EA"
    />
    <path
      d="M167.885 35.7526C171.751 35.7526 174.885 32.6186 174.885 28.7526C174.885 24.8866 171.751 21.7526 167.885 21.7526C164.019 21.7526 160.885 24.8866 160.885 28.7526C160.885 32.6186 164.019 35.7526 167.885 35.7526Z"
      fill="white"
    />
    <path
      d="M37.8848 185.753C41.7507 185.753 44.8848 182.619 44.8848 178.753C44.8848 174.887 41.7507 171.753 37.8848 171.753C34.0188 171.753 30.8848 174.887 30.8848 178.753C30.8848 182.619 34.0188 185.753 37.8848 185.753Z"
      fill="white"
    />
    <path
      d="M191.885 157C192.989 157 193.885 156.105 193.885 155C193.885 153.895 192.989 153 191.885 153C190.78 153 189.885 153.895 189.885 155C189.885 156.105 190.78 157 191.885 157Z"
      fill="#C5B8EA"
    />
    <path
      d="M35.5128 30.301C38.3573 30.301 40.6633 27.995 40.6633 25.1505C40.6633 22.306 38.3573 20 35.5128 20C32.6683 20 30.3623 22.306 30.3623 25.1505C30.3623 27.995 32.6683 30.301 35.5128 30.301Z"
      fill="white"
    />
    <path
      d="M19.0123 30.3C20.4759 30.3 21.6623 29.1136 21.6623 27.65C21.6623 26.1864 20.4759 25 19.0123 25C17.5487 25 16.3623 26.1864 16.3623 27.65C16.3623 29.1136 17.5487 30.3 19.0123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.3906 195C36.0475 195 37.3906 193.657 37.3906 192C37.3906 190.343 36.0475 189 34.3906 189C32.7338 189 31.3906 190.343 31.3906 192C31.3906 193.657 32.7338 195 34.3906 195Z"
      fill="#C5B8EA"
    />
    <path
      d="M79.6736 77.6906L87.0843 51.5516L118.436 55.1629L107.961 71.9533C107.693 72.3839 107.789 72.9475 108.186 73.2644L115.358 78.9951C115.717 79.2815 115.835 79.7752 115.644 80.1926L97.7151 119.408L98.7321 88.4978L80.1747 78.8511C79.7535 78.6321 79.5441 78.1473 79.6736 77.6906Z"
      fill="white"
    />
    <path
      d="M84.899 75.5855L91.3571 55.1628L118.436 55.1628L107.961 71.9532C107.693 72.3839 107.789 72.9475 108.186 73.2643L115.358 78.995C115.717 79.2815 115.835 79.7752 115.644 80.1926L97.7151 119.408L102.096 86.8354C102.151 86.4283 101.951 86.0291 101.592 85.8288L85.3648 76.7604C84.9505 76.5288 84.7559 76.038 84.899 75.5855Z"
      fill="url(#paint1_linear_1400_37150)"
    />
    <g filter="url(#filter2_i_1400_37150)">
      <rect
        x="95.7402"
        y="13"
        width="6"
        height="33"
        rx="3"
        fill="url(#paint2_linear_1400_37150)"
      />
    </g>
    <g filter="url(#filter3_i_1400_37150)">
      <path
        d="M113.719 26.7934C114.241 25.2102 115.969 24.3721 117.535 24.9422C119.068 25.5002 119.859 27.1953 119.301 28.7283L113.775 43.9101C113.379 44.9983 112.334 45.7138 111.177 45.69C109.357 45.6526 108.093 43.866 108.662 42.1377L113.719 26.7934Z"
        fill="url(#paint3_linear_1400_37150)"
      />
    </g>
    <g filter="url(#filter4_i_1400_37150)">
      <path
        d="M81.0026 36.9626C80.4489 35.4413 81.2333 33.7591 82.7546 33.2054C84.3253 32.6337 86.0554 33.4892 86.5547 35.0844L89.1319 43.319C89.6767 45.0596 88.3968 46.8354 86.5732 46.8691C85.4056 46.8907 84.3531 46.1681 83.9537 45.0707L81.0026 36.9626Z"
        fill="url(#paint4_linear_1400_37150)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1400_37150"
        x="30"
        y="25.7864"
        width="140.594"
        height="144.737"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-4.21361" />
        <feGaussianBlur stdDeviation="7.49086" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1400_37150"
        />
      </filter>
      <filter
        id="filter1_i_1400_37150"
        x="47"
        y="60"
        width="112.913"
        height="87"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="10" />
        <feGaussianBlur stdDeviation="3.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.6 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1400_37150"
        />
      </filter>
      <filter
        id="filter2_i_1400_37150"
        x="95.7402"
        y="13"
        width="7"
        height="34"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1400_37150"
        />
      </filter>
      <filter
        id="filter3_i_1400_37150"
        x="108.524"
        y="24.7632"
        width="11.9551"
        height="21.9274"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1400_37150"
        />
      </filter>
      <filter
        id="filter4_i_1400_37150"
        x="80.8252"
        y="33.0277"
        width="9.43311"
        height="14.8419"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1400_37150"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1400_37150"
        x1="99.9565"
        y1="60"
        x2="85.9805"
        y2="150.856"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1400_37150"
        x1="103.885"
        y1="54.2811"
        x2="99.5"
        y2="114.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.416679" stopColor="#EDF1FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1400_37150"
        x1="98.7402"
        y1="13"
        x2="111.903"
        y2="18.423"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1400_37150"
        x1="117.492"
        y1="24.9265"
        x2="125.864"
        y2="35.1733"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_1400_37150"
        x1="82.8191"
        y1="33.1819"
        x2="93.5316"
        y2="37.4167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const DownloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M14.5 10V12.6667C14.5 13.0203 14.3595 13.3594 14.1095 13.6095C13.8594 13.8595 13.5203 14 13.1667 14H3.83333C3.47971 14 3.14057 13.8595 2.89052 13.6095C2.64048 13.3594 2.5 13.0203 2.5 12.6667V10"
      stroke="white"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16675 6.66667L8.50008 10L11.8334 6.66667"
      stroke="white"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 10V2"
      stroke="white"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clipPath="url(#clip0_231_72122)">
      <path
        d="M15.8333 2.66667V6.66667H11.8333"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.16 10C13.7266 11.2266 12.9064 12.2791 11.8228 12.999C10.7392 13.7189 9.45097 14.067 8.15228 13.9911C6.85359 13.9151 5.61477 13.4191 4.6225 12.5778C3.63024 11.7365 2.93828 10.5955 2.65091 9.3267C2.36354 8.05793 2.49632 6.73013 3.02924 5.54338C3.56217 4.35663 4.46636 3.37524 5.60557 2.74709C6.74478 2.11894 8.05729 1.87807 9.34531 2.06076C10.6333 2.24346 11.8271 2.83983 12.7467 3.76L15.8333 6.66667"
        stroke="white"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_231_72122">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const SessionExpired = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="201"
    height="200"
    viewBox="0 0 201 200"
    fill="none"
  >
    <rect x="0.5" width="200" height="200" rx="100" fill="#F0F2FA" />
    <g filter="url(#filter0_i_231_72167)">
      <path
        d="M106.099 37.6746H92.9888V46.207H106.099V37.6746Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter1_i_231_72167)">
      <path
        d="M56.4052 54.6706L49.291 61.7812L54.465 66.9525L61.5792 59.8419L56.4052 54.6706Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter2_i_231_72167)">
      <path
        d="M139.599 59.3179L146.713 66.4285L151.348 61.7958L144.234 54.6852L139.599 59.3179Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter3_i_231_72167)">
      <path
        d="M100.61 170.999C135.465 170.999 163.72 142.758 163.72 107.921C163.72 73.0831 135.465 44.8418 100.61 44.8418C65.7554 44.8418 37.5 73.0831 37.5 107.921C37.5 142.758 65.7554 170.999 100.61 170.999Z"
        fill="url(#paint0_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter4_i_231_72167)">
      <path
        d="M148.976 107.538C148.062 133.897 126.415 155.076 99.7382 155.076C73.0611 155.076 51.4146 133.897 50.5 107.538C51.4146 81.1794 73.0611 60.0007 99.7382 60.0007C126.415 59.8484 148.062 81.027 148.976 107.538Z"
        fill="#F0EDFA"
      />
    </g>
    <g filter="url(#filter5_i_231_72167)">
      <circle cx="99.959" cy="107.459" r="17.459" fill="#D92D20" />
    </g>
    <path
      d="M97.4683 97.4841H102.379L101.069 111.125H98.7778L97.4683 97.4841Z"
      fill="white"
    />
    <ellipse cx="99.9236" cy="115.49" rx="2.45535" ry="2.18253" fill="white" />
    <g filter="url(#filter6_i_231_72167)">
      <path
        d="M145.141 109.78H139.9C139.01 109.78 138.317 108.713 138.317 107.342C138.317 105.971 139.01 104.904 139.9 104.904H145.141C146.031 104.904 146.724 105.971 146.724 107.342C146.724 108.713 145.933 109.78 145.141 109.78Z"
        fill="url(#paint1_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter7_i_231_72167)">
      <path
        d="M60.2375 109.78H54.9959C54.1059 109.78 53.4136 108.713 53.4136 107.342C53.4136 105.971 54.1059 104.904 54.9959 104.904H60.2375C61.1276 104.904 61.8199 105.971 61.8199 107.342C61.8199 108.713 61.0287 109.78 60.2375 109.78Z"
        fill="url(#paint2_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter8_i_231_72167)">
      <path
        d="M100.406 151.979C99.0339 151.979 97.9668 151.287 97.9668 150.397V145.155C97.9668 144.265 99.0339 143.573 100.406 143.573C101.778 143.573 102.845 144.265 102.845 145.155V148.697C102.845 149.828 102.801 151.142 101.793 151.656C101.394 151.86 100.913 151.979 100.406 151.979Z"
        fill="url(#paint3_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter9_i_231_72167)">
      <path
        d="M100.406 70.4382C99.0339 70.4382 97.9668 69.7377 97.9668 68.837V63.6331C97.9668 62.7324 99.0339 62.0319 100.406 62.0319C101.778 62.0319 102.845 62.7324 102.845 63.6331V67.05C102.845 68.3052 102.731 69.7593 101.564 70.2201C101.215 70.3577 100.819 70.4382 100.406 70.4382Z"
        fill="url(#paint4_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter10_i_231_72167)">
      <path
        d="M112.347 25.6375V33.8652C112.347 37.0648 109.756 39.5026 106.707 39.5026H92.6823C89.481 39.5026 87.042 36.9124 87.042 33.8652V25.6375C87.042 22.4378 89.6335 20 92.6823 20H106.707C109.908 20 112.347 22.5902 112.347 25.6375Z"
        fill="url(#paint5_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter11_i_231_72167)">
      <path
        d="M89.1763 34.7793C88.7189 34.7793 88.4141 34.4746 88.4141 34.0175V24.5709C88.4141 24.1138 88.7189 23.8091 89.1763 23.8091C89.6336 23.8091 89.9385 24.1138 89.9385 24.5709V32.8732C89.9385 33.6311 89.9342 34.7793 89.1763 34.7793Z"
        fill="url(#paint6_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter12_i_231_72167)">
      <path
        d="M92.6841 34.7793C92.2268 34.7793 91.9219 34.4746 91.9219 34.0175V24.5709C91.9219 24.1138 92.2268 23.8091 92.6841 23.8091C93.1414 23.8091 93.4463 24.1138 93.4463 24.5709V34.0175C93.4463 34.4746 93.1414 34.7793 92.6841 34.7793Z"
        fill="url(#paint7_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter13_i_231_72167)">
      <path
        d="M96.3408 34.7793C95.8835 34.7793 95.5786 34.4746 95.5786 34.0175V24.5709C95.5786 24.1138 95.8835 23.8091 96.3408 23.8091C96.7981 23.8091 97.103 24.1138 97.103 24.5709V32.8732C97.103 33.6311 97.0987 34.7793 96.3408 34.7793Z"
        fill="url(#paint8_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter14_i_231_72167)">
      <path
        d="M99.8477 34.7793C99.3903 34.7793 99.0854 34.4746 99.0854 34.0175V24.5709C99.0854 24.1138 99.3903 23.8091 99.8477 23.8091C100.305 23.8091 100.61 24.1138 100.61 24.5709V34.0175C100.61 34.4746 100.305 34.7793 99.8477 34.7793Z"
        fill="url(#paint9_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter15_i_231_72167)">
      <path
        d="M103.507 34.7793C103.05 34.7793 102.745 34.4746 102.745 34.0175V24.5709C102.745 24.1138 103.05 23.8091 103.507 23.8091C103.964 23.8091 104.269 24.1138 104.269 24.5709V32.8732C104.269 33.6311 104.265 34.7793 103.507 34.7793Z"
        fill="url(#paint10_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter16_i_231_72167)">
      <path
        d="M107.012 34.7793C106.554 34.7793 106.25 34.4746 106.25 34.0175V24.5709C106.25 24.1138 106.554 23.8091 107.012 23.8091C107.469 23.8091 107.774 24.1138 107.774 24.5709V34.0175C107.774 34.4746 107.317 34.7793 107.012 34.7793Z"
        fill="url(#paint11_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter17_i_231_72167)">
      <path
        d="M110.52 34.7793C110.062 34.7793 109.757 34.4746 109.757 34.0175V24.5709C109.757 24.1138 110.062 23.8091 110.52 23.8091C110.977 23.8091 111.282 24.1138 111.282 24.5709V34.0175C111.282 34.4746 110.977 34.7793 110.52 34.7793Z"
        fill="url(#paint12_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter18_i_231_72167)">
      <path
        d="M57.7746 55.3485L50.1526 62.9667C48.4757 64.6428 45.7318 64.6428 43.9025 62.9667L39.4818 58.5482C37.8049 56.8722 37.8049 54.1296 39.4818 52.3012L47.1038 44.683C48.7806 43.007 51.5245 43.007 53.3538 44.683L57.7746 49.1016C59.4514 50.93 59.4514 53.6725 57.7746 55.3485Z"
        fill="url(#paint13_linear_231_72167)"
      />
    </g>
    <g filter="url(#filter19_i_231_72167)">
      <path
        d="M142.836 55.3485L150.458 62.9667C152.135 64.6428 154.879 64.6428 156.708 62.9667L161.129 58.5482C162.805 56.8722 162.805 54.1296 161.129 52.3012L153.507 44.683C151.83 43.007 149.086 43.007 147.257 44.683L142.836 49.1016C141.159 50.93 141.159 53.6725 142.836 55.3485Z"
        fill="url(#paint14_linear_231_72167)"
      />
    </g>
    <path
      d="M182.04 159.08C183.995 159.08 185.58 157.495 185.58 155.54C185.58 153.585 183.995 152 182.04 152C180.085 152 178.5 153.585 178.5 155.54C178.5 157.495 180.085 159.08 182.04 159.08Z"
      fill="white"
    />
    <path
      d="M180.535 22.0526C182.274 22.0526 183.685 20.6423 183.685 18.9026C183.685 17.1629 182.274 15.7526 180.535 15.7526C178.795 15.7526 177.385 17.1629 177.385 18.9026C177.385 20.6423 178.795 22.0526 180.535 22.0526Z"
      fill="#C5B8EA"
    />
    <path
      d="M168.385 35.7526C172.251 35.7526 175.385 32.6186 175.385 28.7526C175.385 24.8866 172.251 21.7526 168.385 21.7526C164.519 21.7526 161.385 24.8866 161.385 28.7526C161.385 32.6186 164.519 35.7526 168.385 35.7526Z"
      fill="white"
    />
    <path
      d="M48.3848 185.753C52.2507 185.753 55.3848 182.619 55.3848 178.753C55.3848 174.887 52.2507 171.753 48.3848 171.753C44.5188 171.753 41.3848 174.887 41.3848 178.753C41.3848 182.619 44.5188 185.753 48.3848 185.753Z"
      fill="white"
    />
    <path
      d="M193.385 161C194.489 161 195.385 160.104 195.385 159C195.385 157.895 194.489 157 193.385 157C192.28 157 191.385 157.895 191.385 159C191.385 160.104 192.28 161 193.385 161Z"
      fill="#C5B8EA"
    />
    <path
      d="M36.0128 30.301C38.8573 30.301 41.1633 27.995 41.1633 25.1505C41.1633 22.306 38.8573 20 36.0128 20C33.1683 20 30.8623 22.306 30.8623 25.1505C30.8623 27.995 33.1683 30.301 36.0128 30.301Z"
      fill="white"
    />
    <path
      d="M19.5123 30.3C20.9759 30.3 22.1623 29.1136 22.1623 27.65C22.1623 26.1864 20.9759 25 19.5123 25C18.0487 25 16.8623 26.1864 16.8623 27.65C16.8623 29.1136 18.0487 30.3 19.5123 30.3Z"
      fill="#DCDAE3"
    />
    <path
      d="M34.8906 195C36.5475 195 37.8906 193.657 37.8906 192C37.8906 190.343 36.5475 189 34.8906 189C33.2338 189 31.8906 190.343 31.8906 192C31.8906 193.657 33.2338 195 34.8906 195Z"
      fill="#C5B8EA"
    />
    <defs>
      <filter
        id="filter0_i_231_72167"
        x="92.9888"
        y="32.6746"
        width="18.1099"
        height="13.5324"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter1_i_231_72167"
        x="49.291"
        y="49.6706"
        width="17.2881"
        height="17.2819"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter2_i_231_72167"
        x="139.599"
        y="49.6852"
        width="16.749"
        height="16.7433"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter3_i_231_72167"
        x="37.5"
        y="39.8418"
        width="131.221"
        height="131.158"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="5" dy="-5" />
        <feGaussianBlur stdDeviation="4.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter4_i_231_72167"
        x="50.5"
        y="52.9999"
        width="106.477"
        height="102.076"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter5_i_231_72167"
        x="82.5"
        y="85"
        width="39.918"
        height="39.918"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="8" dy="-7" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.596078 0 0 0 0 0.121569 0 0 0 0 0.0862745 0 0 0 0.28 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter6_i_231_72167"
        x="138.317"
        y="103.904"
        width="8.40625"
        height="5.87566"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter7_i_231_72167"
        x="53.4136"
        y="104.904"
        width="8.40625"
        height="4.87566"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter8_i_231_72167"
        x="97.9668"
        y="143.573"
        width="6.87793"
        height="8.40631"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="3" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter9_i_231_72167"
        x="97.9668"
        y="62.0319"
        width="6.87793"
        height="8.40631"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter10_i_231_72167"
        x="81.042"
        y="14"
        width="31.3052"
        height="25.5026"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-6" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter11_i_231_72167"
        x="88.4141"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter12_i_231_72167"
        x="91.9219"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter13_i_231_72167"
        x="95.5786"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter14_i_231_72167"
        x="99.0854"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter15_i_231_72167"
        x="102.745"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter16_i_231_72167"
        x="106.25"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter17_i_231_72167"
        x="109.757"
        y="23.8091"
        width="2.52441"
        height="11.9702"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2" dy="3" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.556863 0 0 0 0 0.462745 0 0 0 0 0.843137 0 0 0 0.9 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter18_i_231_72167"
        x="32.2241"
        y="37.426"
        width="26.8081"
        height="26.7977"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-6" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <filter
        id="filter19_i_231_72167"
        x="135.578"
        y="37.426"
        width="26.8081"
        height="26.7977"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-10" dy="-6" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.262745 0 0 0 0 0.105882 0 0 0 0 0.737255 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_231_72167"
        />
      </filter>
      <linearGradient
        id="paint0_linear_231_72167"
        x1="100.61"
        y1="44.8418"
        x2="161.042"
        y2="171.023"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_231_72167"
        x1="142.521"
        y1="104.904"
        x2="143.847"
        y2="110.086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_231_72167"
        x1="57.6167"
        y1="104.904"
        x2="58.943"
        y2="110.086"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_231_72167"
        x1="100.406"
        y1="143.573"
        x2="104.993"
        y2="149.605"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_231_72167"
        x1="100.406"
        y1="62.0319"
        x2="104.993"
        y2="68.0633"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_231_72167"
        x1="99.6945"
        y1="20"
        x2="107.488"
        y2="41.1025"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_231_72167"
        x1="89.1763"
        y1="23.8091"
        x2="92.7352"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_231_72167"
        x1="92.6841"
        y1="23.8091"
        x2="96.243"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_231_72167"
        x1="96.3408"
        y1="23.8091"
        x2="99.8997"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_231_72167"
        x1="99.8477"
        y1="23.8091"
        x2="103.407"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_231_72167"
        x1="103.507"
        y1="23.8091"
        x2="107.066"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_231_72167"
        x1="107.012"
        y1="23.8091"
        x2="110.571"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_231_72167"
        x1="110.52"
        y1="23.8091"
        x2="114.078"
        y2="24.9298"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_231_72167"
        x1="48.6282"
        y1="43.426"
        x2="58.5906"
        y2="64.2276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_231_72167"
        x1="151.982"
        y1="43.426"
        x2="161.945"
        y2="64.2276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#413BBC" />
        <stop offset="1" stopColor="#A9A6E2" />
      </linearGradient>
    </defs>
  </svg>
);
export const AustraliaFlag = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
  >
    <path
      d="M14.2222 0.222221H1.77778C1.68667 0.222221 1.59689 0.228888 1.50934 0.242221L1.50756 1.02178L0.294224 1.02C0.101845 1.31059 -0.00050313 1.6515 1.85974e-06 2V10C1.85974e-06 10.4715 0.187303 10.9237 0.520701 11.2571C0.854099 11.5905 1.30628 11.7778 1.77778 11.7778H14.2222C14.6937 11.7778 15.1459 11.5905 15.4793 11.2571C15.8127 10.9237 16 10.4715 16 10V2C16 1.5285 15.8127 1.07632 15.4793 0.74292C15.1459 0.409522 14.6937 0.222221 14.2222 0.222221Z"
      fill="#00247D"
    />
    <path
      d="M4.00001 9.56578L3.4569 10.0676L3.51068 9.32978L2.77957 9.21822L3.38979 8.80044L3.02135 8.15911L3.72846 8.376L4.00001 7.68756L4.27201 8.376L4.97912 8.15911L4.61023 8.80044L5.2209 9.21822L4.48979 9.32978L4.54357 10.0676L4.00001 9.56578ZM12.4222 2.24978L12.0671 2.57778L12.1022 2.09511L11.6236 2.02222L12.0231 1.74889L11.7822 1.32933L12.2445 1.47111L12.4222 1.02089L12.6005 1.47111L13.0631 1.32933L12.8218 1.74889L13.2209 2.02222L12.7427 2.09511L12.7778 2.57778L12.4222 2.24978ZM10.6445 4.91644L10.2893 5.24489L10.3245 4.76222L9.84579 4.68933L10.2453 4.41556L10.0045 3.996L10.4667 4.13778L10.6445 3.68756L10.8227 4.13778L11.2853 3.996L11.044 4.41556L11.4431 4.68933L10.9649 4.76222L11 5.24489L10.6445 4.91644ZM14.6445 4.02756L14.2893 4.356L14.3245 3.87333L13.8458 3.80044L14.2453 3.52667L14.0045 3.10711L14.4667 3.24889L14.6445 2.79867L14.8227 3.24889L15.2853 3.10711L15.044 3.52667L15.4431 3.80044L14.9649 3.87333L15 4.356L14.6445 4.02756ZM12.4222 10.2498L12.0671 10.5782L12.1022 10.0956L11.6236 10.0227L12.0231 9.74889L11.7822 9.32933L12.2445 9.47111L12.4222 9.02089L12.6005 9.47111L13.0631 9.32933L12.8218 9.74889L13.2209 10.0227L12.7427 10.0956L12.7778 10.5782L12.4222 10.2498ZM13.7778 5.11111L13.9085 5.376L14.2005 5.41822L13.9893 5.624L14.0391 5.91511L13.7778 5.77778L13.5165 5.91511L13.5662 5.624L13.3551 5.41822L13.6471 5.376L13.7778 5.11111Z"
      fill="white"
    />
    <path
      d="M8.44444 6V0.222221H1.77778C1.63556 0.222221 1.50933 0.242221 1.50933 0.242221L1.50756 1.02178L0.294223 1.02C0.294223 1.02 0.275557 1.04622 0.237779 1.11111C0.0816515 1.38131 -0.000371753 1.68794 1.26663e-06 2V6H8.44444Z"
      fill="#00247D"
    />
    <path
      d="M8.44444 0.222221H7.40844L5.33333 1.67511V0.222221H3.11111V1.364L1.50933 0.242221C1.24216 0.282132 0.987827 0.383286 0.766222 0.537777L2.856 2H2.08444L0.429778 0.840443C0.380981 0.897481 0.335712 0.957445 0.294222 1.02L1.69467 2H0V4.22222H1.72667L0 5.45155V6H1.48089L3.11111 4.85867V6H5.33333V4.54711L7.408 6H8.44444V5.09822L7.19333 4.22222H8.44444V2H7.19378L8.44444 1.124V0.222221Z"
      fill="#EEEEEE"
    />
    <path
      d="M4.88889 0.222221H3.55556V2.44444H0V3.77778H3.55556V6H4.88889V3.77778H8.44444V2.44444H4.88889V0.222221Z"
      fill="#CF1B2B"
    />
    <path
      d="M8.44445 0.222221H7.79511L5.33334 1.94622V2H6.03156L8.44445 0.310221V0.222221ZM0.766225 0.537777C0.641796 0.624117 0.528756 0.725809 0.429781 0.840443L2.08445 2H2.85556L0.766225 0.537777ZM2.86089 4.22222L0.326225 6H1.09378L3.11111 4.58755V4.22222H2.86089ZM8.44445 5.912V5.36978L6.80578 4.22222H6.03111L8.44445 5.912Z"
      fill="#CF1B2B"
    />
  </svg>
);

export const TickSelect = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6.93652L9 17.9365L4 12.9365"
      stroke="var(--inte-P900)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

// Dashboard

export const Incomplete = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#FFF3F2" />
    <g clipPath="url(#clip0_1461_60095)">
      <path
        d="M30 20H26L23 29L17 11L14 20H10"
        stroke="#FF8277"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6714 12.493L32.994 30.8903"
        stroke="#FFF3F2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0049 12.1097L30.3275 30.507"
        stroke="#FF8277"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1461_60095">
        <rect width="24" height="24" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const Finished = (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#ECFBED" />
    <path
      d="M30.5 19.0857V20.0057C30.4988 22.1621 29.8005 24.2604 28.5093 25.9875C27.2182 27.7147 25.4033 28.9782 23.3354 29.5896C21.2674 30.201 19.0573 30.1276 17.0345 29.3803C15.0117 28.633 13.2847 27.2518 12.111 25.4428C10.9373 23.6338 10.3798 21.4938 10.5217 19.342C10.6636 17.1903 11.4972 15.142 12.8983 13.5028C14.2994 11.8635 16.1928 10.7211 18.2962 10.2459C20.3996 9.77063 22.6003 9.98806 24.57 10.8657"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.5 11.9048L20.4878 22.0635L17.4841 19.0189"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CrossError = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#FFEBEA" />
    <path
      d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      stroke="#FC372D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0698 12.93L12.9298 27.07"
      stroke="#FC372D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cancelled = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#FFEBEA" />
    <path
      d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      stroke="#FC372D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 17L17 23"
      stroke="#FC372D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 17L23 23"
      stroke="#FC372D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const EyeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M0.666626 8.00008C0.666626 8.00008 3.33329 2.66675 7.99996 2.66675C12.6666 2.66675 15.3333 8.00008 15.3333 8.00008C15.3333 8.00008 12.6666 13.3334 7.99996 13.3334C3.33329 13.3334 0.666626 8.00008 0.666626 8.00008Z"
      stroke="#1C2433"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#1C2433"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Warning = (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#FFFAEC" />
    <path
      d="M18.8633 10.7571L10.7565 24.8168C10.5894 25.1175 10.5009 25.4585 10.5 25.8057C10.4991 26.1529 10.5857 26.4944 10.7512 26.7961C10.9167 27.0977 11.1554 27.3491 11.4435 27.5252C11.7315 27.7013 12.059 27.796 12.3932 27.7998H28.6068C28.941 27.796 29.2685 27.7013 29.5565 27.5252C29.8446 27.3491 30.0833 27.0977 30.2488 26.7961C30.4143 26.4944 30.5009 26.1529 30.5 25.8057C30.4991 25.4585 30.4106 25.1175 30.2435 24.8168L22.1367 10.7571C21.966 10.4649 21.7258 10.2233 21.4391 10.0556C21.1524 9.88789 20.829 9.7998 20.5 9.7998C20.171 9.7998 19.8476 9.88789 19.5609 10.0556C19.2742 10.2233 19.034 10.4649 18.8633 10.7571Z"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 16.0409V19.2409"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 23.2979H20.5096"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Warning2 = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57502 3.21672L1.51668 15C1.37116 15.2521 1.29416 15.5378 1.29334 15.8288C1.29253 16.1198 1.36793 16.406 1.51204 16.6588C1.65615 16.9116 1.86396 17.1223 2.11477 17.2699C2.36559 17.4175 2.65068 17.4969 2.94168 17.5H17.0583C17.3494 17.4969 17.6344 17.4175 17.8853 17.2699C18.1361 17.1223 18.3439 16.9116 18.488 16.6588C18.6321 16.406 18.7075 16.1198 18.7067 15.8288C18.7059 15.5378 18.6289 15.2521 18.4834 15L11.425 3.21672C11.2765 2.9718 11.0673 2.76931 10.8177 2.62879C10.5681 2.48826 10.2865 2.41443 10 2.41443C9.71357 2.41443 9.43196 2.48826 9.18235 2.62879C8.93275 2.76931 8.72358 2.9718 8.57502 3.21672V3.21672Z"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V10.8333"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1666H10.01"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Imported = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#F1ECFD" />
    <path
      d="M30 23V27.6667C30 28.2855 29.7659 28.879 29.3491 29.3166C28.9324 29.7542 28.3671 30 27.7778 30H12.2222C11.6329 30 11.0676 29.7542 10.6509 29.3166C10.2341 28.879 10 28.2855 10 27.6667V23"
      stroke="#7842E8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4445 18.1777L20 23.7332M20 23.7332L25.5556 18.1777M20 23.7332V10"
      stroke="#7842E8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Pending = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#E0E1E3" />
    <path
      d="M16.36 10H24.64L30.5 15.86V24.14L24.64 30H16.36L10.5 24.14V15.86L16.36 10Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 16V20"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5 24H20.51"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Refunded = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#F0F4FF" />
    <path
      d="M24.75 17.8333L17.25 13.5083"
      stroke="#6692FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.5 23.3333V16.6667C28.4997 16.3744 28.4225 16.0873 28.2763 15.8343C28.13 15.5813 27.9198 15.3711 27.6667 15.225L21.8333 11.8917C21.58 11.7454 21.2926 11.6684 21 11.6684C20.7074 11.6684 20.42 11.7454 20.1667 11.8917L14.3333 15.225C14.0802 15.3711 13.87 15.5813 13.7237 15.8343C13.5775 16.0873 13.5003 16.3744 13.5 16.6667V23.3333C13.5003 23.6256 13.5775 23.9127 13.7237 24.1657C13.87 24.4187 14.0802 24.6289 14.3333 24.775L20.1667 28.1083C20.42 28.2546 20.7074 28.3316 21 28.3316C21.2926 28.3316 21.58 28.2546 21.8333 28.1083L27.6667 24.775C27.9198 24.6289 28.13 24.4187 28.2763 24.1657C28.4225 23.9127 28.4997 23.6256 28.5 23.3333Z"
      stroke="#6692FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.725 15.8L21 20.0083L28.275 15.8"
      stroke="#6692FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 28.4V20"
      stroke="#6692FB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NotUploaded = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#FFFAEC" />
    <path
      d="M27.1665 22.9515V26.4758C27.1665 26.9431 26.9909 27.3913 26.6783 27.7218C26.3658 28.0522 25.9419 28.2379 25.4998 28.2379H13.8332C13.3911 28.2379 12.9672 28.0522 12.6547 27.7218C12.3421 27.3913 12.1665 26.9431 12.1665 26.4758V22.9515M23.8332 16.7841L19.6665 12.3788M19.6665 12.3788L15.4998 16.7841M19.6665 12.3788V22.9515"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1665 10L30.4998 29.3833"
      stroke="#FFFAEC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 10.6167L28.8333 30"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#E0E1E3" />
    <path
      d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 14.8V20L23.6 21.6"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Like = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#ECFBED" />
    <g clipPath="url(#clip0_763_47057)">
      <path
        d="M15.8334 19.1667L19.1667 11.6667C19.8298 11.6667 20.4657 11.9301 20.9345 12.3989C21.4034 12.8677 21.6667 13.5036 21.6667 14.1667V17.5H26.3834C26.625 17.4973 26.8643 17.5471 27.0847 17.646C27.3051 17.7449 27.5014 17.8906 27.66 18.0729C27.8185 18.2552 27.9355 18.4699 28.0029 18.7019C28.0702 18.9339 28.0863 19.1778 28.0501 19.4167L26.9001 26.9167C26.8398 27.3141 26.6379 27.6763 26.3317 27.9367C26.0254 28.197 25.6354 28.3379 25.2334 28.3333H15.8334M15.8334 19.1667V28.3333M15.8334 19.1667H13.3334C12.8914 19.1667 12.4675 19.3423 12.1549 19.6548C11.8423 19.9674 11.6667 20.3913 11.6667 20.8333V26.6667C11.6667 27.1087 11.8423 27.5326 12.1549 27.8452C12.4675 28.1577 12.8914 28.3333 13.3334 28.3333H15.8334"
        stroke="#46D64B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_763_47057">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Dislike = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#FFFAEC" />
    <path
      d="M24.6667 20.8333L21.3334 28.3333C20.6703 28.3333 20.0344 28.0699 19.5656 27.6011C19.0968 27.1323 18.8334 26.4964 18.8334 25.8333V22.5H14.1167C13.8751 22.5027 13.6358 22.4529 13.4154 22.354C13.195 22.2551 12.9987 22.1094 12.8401 21.9271C12.6816 21.7448 12.5646 21.5302 12.4972 21.2981C12.4299 21.0661 12.4138 20.8222 12.45 20.5833L13.6 13.0833C13.6603 12.6859 13.8622 12.3237 14.1684 12.0633C14.4747 11.803 14.8648 11.6621 15.2667 11.6667H24.6667M24.6667 20.8333V11.6667M24.6667 20.8333H26.8917C27.3633 20.8417 27.8216 20.6766 28.1795 20.3693C28.5375 20.0621 28.7701 19.6341 28.8334 19.1667V13.3333C28.7701 12.8659 28.5375 12.4379 28.1795 12.1307C27.8216 11.8234 27.3633 11.6583 26.8917 11.6667H24.6667"
      stroke="#FEC84B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UploadUp = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#ECFBED" />
    <path
      d="M27.6665 22.9515V26.4758C27.6665 26.9431 27.4909 27.3913 27.1783 27.7218C26.8658 28.0522 26.4419 28.2379 25.9998 28.2379H14.3332C13.8911 28.2379 13.4672 28.0522 13.1547 27.7218C12.8421 27.3913 12.6665 26.9431 12.6665 26.4758V22.9515M24.3332 16.7841L20.1665 12.3788M20.1665 12.3788L15.9998 16.7841M20.1665 12.3788V22.9515"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Shipping = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <rect width="40" height="40" rx="20" fill="#E0E1E3" />
    <path
      d="M25.8908 12H12.7999V23.3455H25.8908V12Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.8906 16.3635H29.3815L31.9997 18.9817V23.3454H25.8906V16.3635Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7276 27.709C17.9326 27.709 18.9094 26.7322 18.9094 25.5272C18.9094 24.3222 17.9326 23.3454 16.7276 23.3454C15.5226 23.3454 14.5458 24.3222 14.5458 25.5272C14.5458 26.7322 15.5226 27.709 16.7276 27.709Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0724 27.709C29.2774 27.709 30.2543 26.7322 30.2543 25.5272C30.2543 24.3222 29.2774 23.3454 28.0724 23.3454C26.8675 23.3454 25.8906 24.3222 25.8906 25.5272C25.8906 26.7322 26.8675 27.709 28.0724 27.709Z"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.28 27.36C16.1961 27.36 18.56 24.9961 18.56 22.08C18.56 19.1639 16.1961 16.8 13.28 16.8C10.3639 16.8 8 19.1639 8 22.08C8 24.9961 10.3639 27.36 13.28 27.36Z"
      fill="#E0E1E3"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M13.28 19.3344V22.08L15.1808 22.9248" fill="#E0E1E3" />
    <path
      d="M13.28 19.3344V22.08L15.1808 22.9248"
      stroke="#1C2433"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="6.5"
      y="15.3"
      width="13.56"
      height="13.56"
      rx="6.78"
      stroke="#E0E1E3"
      strokeWidth="3"
    />
  </svg>
);

export const Shipped = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#ECFBED" />
    <path
      d="M24.8334 12H11.5V23.5556H24.8334V12Z"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.8331 16.4444H28.3887L31.0554 19.1111V23.5555H24.8331V16.4444Z"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5004 28C16.7277 28 17.7227 27.0051 17.7227 25.7778C17.7227 24.5505 16.7277 23.5555 15.5004 23.5555C14.2731 23.5555 13.2782 24.5505 13.2782 25.7778C13.2782 27.0051 14.2731 28 15.5004 28Z"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.0554 28C28.2827 28 29.2776 27.0051 29.2776 25.7778C29.2776 24.5505 28.2827 23.5555 27.0554 23.5555C25.8281 23.5555 24.8331 24.5505 24.8331 25.7778C24.8331 27.0051 25.8281 28 27.0554 28Z"
      stroke="#46D64B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/*PRODUCT LISTING*/
export const Error = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.57514 3.21667L1.51681 15C1.37128 15.252 1.29428 15.5377 1.29346 15.8288C1.29265 16.1198 1.36805 16.4059 1.51216 16.6588C1.65627 16.9116 1.86408 17.1223 2.1149 17.2699C2.36571 17.4175 2.65081 17.4968 2.94181 17.5H17.0585C17.3495 17.4968 17.6346 17.4175 17.8854 17.2699C18.1362 17.1223 18.344 16.9116 18.4881 16.6588C18.6322 16.4059 18.7076 16.1198 18.7068 15.8288C18.706 15.5377 18.629 15.252 18.4835 15L11.4251 3.21667C11.2766 2.97175 11.0674 2.76927 10.8178 2.62874C10.5682 2.48821 10.2866 2.41438 10.0001 2.41438C9.71369 2.41438 9.43208 2.48821 9.18248 2.62874C8.93287 2.76927 8.7237 2.97175 8.57514 3.21667V3.21667Z"
      stroke="#C4281C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V10.8333"
      stroke="#C4281C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1667H10.01"
      stroke="#C4281C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Feed = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.6666 1.66667H4.99992C4.55789 1.66667 4.13397 1.84226 3.82141 2.15482C3.50885 2.46738 3.33325 2.89131 3.33325 3.33333V16.6667C3.33325 17.1087 3.50885 17.5326 3.82141 17.8452C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8452C16.491 17.5326 16.6666 17.1087 16.6666 16.6667V6.66667L11.6666 1.66667Z"
      stroke="#3B424F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 1.66667V6.66667H16.6667"
      stroke="#3B424F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 10.8333H6.66675"
      stroke="#3B424F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3334 14.1667H6.66675"
      stroke="#3B424F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33341 7.5H7.50008H6.66675"
      stroke="#3B424F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Dollar = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_678_55995)">
      <path
        d="M10 0.833336V19.1667"
        stroke="#3B424F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1667 4.16666H7.91667C7.14312 4.16666 6.40125 4.47396 5.85427 5.02094C5.30729 5.56792 5 6.30978 5 7.08333C5 7.85688 5.30729 8.59874 5.85427 9.14573C6.40125 9.69271 7.14312 10 7.91667 10H12.0833C12.8569 10 13.5987 10.3073 14.1457 10.8543C14.6927 11.4013 15 12.1431 15 12.9167C15 13.6902 14.6927 14.4321 14.1457 14.9791C13.5987 15.526 12.8569 15.8333 12.0833 15.8333H5"
        stroke="#3B424F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_55995">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// Settings

export const Copy = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <g clipPath="url(#clip0_411_37782)">
      <path
        d="M16.6667 7.55997H9.16667C8.24619 7.55997 7.5 8.30616 7.5 9.22663V16.7266C7.5 17.6471 8.24619 18.3933 9.16667 18.3933H16.6667C17.5871 18.3933 18.3333 17.6471 18.3333 16.7266V9.22663C18.3333 8.30616 17.5871 7.55997 16.6667 7.55997Z"
        stroke="#2E90FA"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.16675 12.56H3.33341C2.89139 12.56 2.46746 12.3844 2.1549 12.0718C1.84234 11.7592 1.66675 11.3353 1.66675 10.8933V3.3933C1.66675 2.95127 1.84234 2.52735 2.1549 2.21479C2.46746 1.90223 2.89139 1.72663 3.33341 1.72663H10.8334C11.2754 1.72663 11.6994 1.90223 12.0119 2.21479C12.3245 2.52735 12.5001 2.95127 12.5001 3.3933V4.22663"
        stroke="#2E90FA"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_411_37782">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.059967)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const eBay_logoSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="76"
    height="31"
    viewBox="0 0 76 31"
    fill="none"
  >
    <path
      d="M10.2012 6.60652C4.87094 6.60652 0.429199 8.8676 0.429199 15.6901C0.429199 21.095 3.41599 24.4985 10.3386 24.4985C18.487 24.4985 19.0093 19.1309 19.0093 19.1309H15.0612C15.0612 19.1309 14.2147 22.0212 10.0979 22.0212C6.74483 22.0212 4.33327 19.756 4.33327 16.5815H19.4225V14.5891C19.4225 11.4483 17.4286 6.60652 10.2012 6.60652ZM10.0633 9.15269C13.2551 9.15269 15.4309 11.108 15.4309 14.0386H4.42049C4.42049 10.9273 7.26082 9.15269 10.0633 9.15269Z"
      fill="#E53238"
    />
    <path
      d="M19.4197 0V21.0724C19.4197 22.2684 19.3343 23.948 19.3343 23.948H23.0999C23.0999 23.948 23.2353 22.7418 23.2353 21.6393C23.2353 21.6393 25.0958 24.5502 30.1549 24.5502C35.4822 24.5502 39.1009 20.8513 39.1009 15.5525C39.1009 10.6228 35.7771 6.65794 30.1635 6.65794C24.9068 6.65794 23.2734 9.49651 23.2734 9.49651V0H19.4197ZM29.1915 9.26436C32.8092 9.26436 35.1099 11.9494 35.1099 15.5525C35.1099 19.4163 32.4528 21.9438 29.2174 21.9438C25.3562 21.9438 23.2734 18.9288 23.2734 15.5868C23.2734 12.4727 25.1422 9.26436 29.1915 9.26436Z"
      fill="#0064D2"
    />
    <path
      d="M48.46 6.60652C40.4411 6.60652 39.9269 10.9971 39.9269 11.6989H43.9182C43.9182 11.6989 44.1274 9.13555 48.1848 9.13555C50.8212 9.13555 52.8642 10.3425 52.8642 12.6623V13.4881H48.1848C41.9725 13.4881 38.6882 15.3055 38.6882 18.9935C38.6882 22.6228 41.7227 24.5976 45.8236 24.5976C51.4125 24.5976 53.2128 21.5095 53.2128 21.5095C53.2128 22.7378 53.3073 23.9482 53.3073 23.9482H56.8555C56.8555 23.9482 56.7181 22.4479 56.7181 21.488V13.1914C56.7181 7.75118 52.3301 6.60652 48.46 6.60652ZM52.8642 15.9654V17.0665C52.8642 18.5025 51.9779 22.0728 46.7611 22.0728C43.9043 22.0728 42.6795 20.6471 42.6795 18.9933C42.6795 15.9848 46.8042 15.9654 52.8642 15.9654Z"
      fill="#F5AF02"
    />
    <path
      d="M54.5687 7.29518H59.0588L65.503 20.2057L71.9324 7.29518H76L64.2891 30.28H60.0223L63.4015 23.8726L54.5687 7.29518Z"
      fill="#86B817"
    />
  </svg>
);

export const Catch_logoSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="86"
    height="38"
    viewBox="0 0 86 38"
    fill="none"
  >
    <rect x="0.199951" width="85.8" height="37.466" fill="url(#pattern0)" />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_411_37701"
          transform="scale(0.00333333 0.00763359)"
        />
      </pattern>
      <image
        id="image0_411_37701"
        width="300"
        height="131"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const Amazon_logoSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="97"
    height="30"
    viewBox="0 0 97 30"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3531 22.7264C54.7647 26.8585 46.636 29.06 39.625 29.06C29.8029 29.06 20.9968 25.436 14.2907 19.4072C13.7826 18.933 14.2229 18.2895 14.8664 18.6621C22.0806 22.8619 30.9883 25.3682 40.2008 25.3682C46.3989 25.3682 53.2406 24.0812 59.5403 21.4055C60.4886 21.0329 61.2676 22.049 60.3531 22.7264Z"
      fill="#FF9900"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M62.6901 20.0507C61.9789 19.1362 57.9484 19.6104 56.1533 19.8475C55.6114 19.9153 55.5098 19.4411 56.0178 19.1024C59.2354 16.8331 64.4852 17.5105 65.0949 18.2556C65.7045 19.0008 64.9255 24.2844 61.9111 26.7908C61.437 27.1633 60.9967 26.9601 61.1999 26.4521C61.8773 24.7586 63.4014 20.9991 62.6901 20.0507Z"
      fill="#FF9900"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.2549 3.18373V0.982212C56.2549 0.643518 56.492 0.440299 56.7968 0.440299H66.619C66.9238 0.440299 67.1948 0.677387 67.1948 0.982212V2.84503C67.1948 3.14986 66.9238 3.55629 66.4496 4.23368L61.3692 11.4817C63.2659 11.4479 65.2642 11.7188 66.9577 12.6672C67.3302 12.8704 67.4319 13.2091 67.4657 13.5139V15.8509C67.4657 16.1896 67.127 16.5622 66.7545 16.3589C63.7401 14.7671 59.7096 14.5977 56.3904 16.3928C56.0517 16.5622 55.6791 16.2235 55.6791 15.8848V13.6494C55.6791 13.3107 55.6792 12.701 56.0517 12.1591L61.945 3.72564H56.8307C56.5259 3.72564 56.2549 3.48855 56.2549 3.18373ZM20.4549 16.8331H17.4744C17.2034 16.7992 16.9664 16.596 16.9325 16.3251V1.01608C16.9325 0.711259 17.2034 0.47417 17.5083 0.47417H20.2856C20.5904 0.47417 20.7936 0.711257 20.8275 0.982212V2.98051H20.8952C21.6065 1.04995 22.9951 0.135476 24.8241 0.135476C26.6869 0.135476 27.8723 1.04995 28.6852 2.98051C29.3964 1.04995 31.056 0.135476 32.8173 0.135476C34.0704 0.135476 35.4252 0.643518 36.2719 1.82895C37.2203 3.11599 37.0171 4.97881 37.0171 6.63842V16.3251C37.0171 16.6299 36.7461 16.867 36.4413 16.867H33.4947C33.1898 16.8331 32.9527 16.596 32.9527 16.3251V8.1964C32.9527 7.55288 33.0205 5.92715 32.885 5.3175C32.6479 4.30142 32.0044 3.99659 31.1238 3.99659C30.4125 3.99659 29.6335 4.47077 29.3287 5.24977C29.0239 6.02876 29.0577 7.3158 29.0577 8.1964V16.3251C29.0577 16.6299 28.7868 16.867 28.482 16.867H25.5015C25.1966 16.8331 24.9595 16.596 24.9595 16.3251V8.1964C24.9595 6.50293 25.2305 3.96272 23.1306 3.96272C20.9968 3.96272 21.0646 6.40132 21.0646 8.1964V16.3251C21.0307 16.596 20.7936 16.8331 20.4549 16.8331ZM75.6621 0.135476C80.099 0.135476 82.5038 3.92886 82.5038 8.77219C82.5038 13.4462 79.8619 17.1718 75.6621 17.1718C71.3268 17.1718 68.956 13.3784 68.956 8.63671C68.9221 3.86112 71.3268 0.135476 75.6621 0.135476ZM75.6621 3.28533C73.4606 3.28533 73.3251 6.29972 73.3251 8.16254C73.3251 10.0254 73.2913 14.022 75.6283 14.022C77.9314 14.022 78.0669 10.8044 78.0669 8.83993C78.0669 7.55289 77.9991 5.9949 77.6266 4.7756C77.2879 3.69177 76.6105 3.28533 75.6621 3.28533ZM88.2277 16.8331H85.2472C84.9424 16.7992 84.7053 16.5622 84.7053 16.2912V0.948341C84.7392 0.677385 84.9762 0.440299 85.2811 0.440299H88.0584C88.3293 0.440299 88.5325 0.643522 88.6003 0.880608V3.2176H88.668C89.5147 1.11769 90.6663 0.135476 92.7323 0.135476C94.0532 0.135476 95.3742 0.609644 96.2209 1.93055C96.9999 3.14985 96.9999 5.21589 96.9999 6.70615V16.3589C96.966 16.6299 96.7289 16.8331 96.4241 16.8331H93.4436C93.1726 16.7992 92.9356 16.596 92.9017 16.3589V8.02706C92.9017 6.33358 93.1049 3.89499 91.0389 3.89499C90.3276 3.89499 89.6502 4.36916 89.3115 5.11429C88.9051 6.06264 88.8373 6.9771 88.8373 8.02706V16.2912C88.8035 16.596 88.5325 16.8331 88.2277 16.8331ZM48.4311 9.51732C48.4311 10.6689 48.465 11.6511 47.8892 12.701C47.415 13.5478 46.6699 14.0558 45.8231 14.0558C44.6716 14.0558 43.9942 13.1752 43.9942 11.8882C43.9942 9.34797 46.2634 8.87379 48.4311 8.87379V9.51732ZM51.4455 16.7993C51.2422 16.9686 50.9713 17.0025 50.7342 16.867C49.752 16.0541 49.5488 15.6477 49.0069 14.8687C47.3811 16.5283 46.1957 17.0363 44.0958 17.0363C41.5894 17.0363 39.625 15.4783 39.625 12.3962C39.625 9.95762 40.9459 8.33188 42.8088 7.51901C44.4345 6.80776 46.7037 6.67229 48.4311 6.46907V6.0965C48.4311 5.38524 48.4988 4.53851 48.0585 3.92886C47.686 3.38695 47.0086 3.14986 46.3989 3.14986C45.2474 3.14986 44.2313 3.72564 43.9942 4.94494C43.9264 5.2159 43.7571 5.48685 43.4861 5.48685L40.6072 5.18202C40.3702 5.11428 40.0992 4.94494 40.1669 4.57238C40.8443 1.04995 43.9942 0 46.8392 0C48.2956 0 50.1923 0.372562 51.3439 1.49025C52.8002 2.84503 52.6648 4.67399 52.6648 6.63842V11.2785C52.6648 12.6672 53.2405 13.2768 53.7825 14.0558C53.9857 14.3268 54.0195 14.6655 53.7825 14.8348C53.1389 15.3429 52.0551 16.2912 51.4455 16.7993ZM9.31186 9.51732C9.31186 10.6689 9.34572 11.6511 8.76994 12.701C8.29577 13.5478 7.55064 14.0558 6.7039 14.0558C5.55234 14.0558 4.87495 13.1752 4.87495 11.8882C4.87495 9.34797 7.14421 8.87379 9.31186 8.87379V9.51732ZM12.2924 16.7993C12.0891 16.9686 11.8182 17.0025 11.5811 16.867C10.5989 16.0541 10.3957 15.6477 9.85376 14.8687C8.22803 16.5283 7.0426 17.0363 4.94269 17.0363C2.43635 17.0363 0.471924 15.4783 0.471924 12.3962C0.471924 9.95762 1.79283 8.33188 3.65565 7.51901C5.28139 6.80776 7.55064 6.67229 9.27798 6.46907V6.0965C9.27798 5.38524 9.34572 4.53851 8.90542 3.92886C8.53285 3.38695 7.85547 3.14986 7.24582 3.14986C6.09425 3.14986 5.07817 3.72564 4.84108 4.94494C4.77334 5.2159 4.604 5.48685 4.33304 5.48685L1.45414 5.18202C1.21705 5.11428 0.946098 4.94494 1.01384 4.57238C1.69123 1.04995 4.84109 0 7.68612 0C9.14251 0 11.0392 0.372562 12.1908 1.49025C13.6471 2.84503 13.5117 4.67399 13.5117 6.63842V11.2785C13.5117 12.6672 14.0874 13.2768 14.6294 14.0558C14.8326 14.3268 14.8664 14.6655 14.6294 14.8348C13.9858 15.3429 12.902 16.2912 12.2924 16.7993Z"
      fill="black"
    />
  </svg>
);

export const ShoplineIconSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="116"
    height="21"
    viewBox="0 0 116 21"
    fill="none"
  >
    <rect
      x="0.285645"
      y="0.059967"
      width="115.714"
      height="20"
      fill="url(#pattern1)"
    />
    <defs>
      <pattern
        id="pattern1"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0_411_37802"
          transform="scale(0.00308642 0.0178571)"
        />
      </pattern>
      <image
        id="image0_411_37802"
        width="324"
        height="56"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

export const CountryLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="19"
    viewBox="0 0 25 19"
    fill="none"
  >
    <path
      d="M21.8844 0.279999H2.73556C2.59536 0.279999 2.45722 0.290257 2.32249 0.310774L2.31975 1.51031L0.452737 1.50758C0.156714 1.95473 -0.000774191 2.4793 2.86168e-06 3.01555V15.3256C2.86168e-06 16.0511 0.288212 16.7469 0.801229 17.2599C1.31424 17.7729 2.01004 18.0611 2.73556 18.0611H21.8844C22.61 18.0611 23.3058 17.7729 23.8188 17.2599C24.3318 16.7469 24.62 16.0511 24.62 15.3256V3.01555C24.62 2.29004 24.3318 1.59424 23.8188 1.08122C23.3058 0.568208 22.61 0.279999 21.8844 0.279999Z"
      fill="#00247D"
    />
    <path
      d="M6.15503 14.6574L5.31932 15.4295L5.40207 14.2943L4.27707 14.1226L5.21605 13.4797L4.6491 12.4929L5.73717 12.8266L6.15503 11.7673L6.57357 12.8266L7.66163 12.4929L7.09401 13.4797L8.03367 14.1226L6.90867 14.2943L6.99142 15.4295L6.15503 14.6574ZM19.1147 3.3999L18.5683 3.90461L18.6223 3.16191L17.8858 3.04975L18.5006 2.62916L18.1299 1.98357L18.8412 2.20173L19.1147 1.50895L19.389 2.20173L20.1009 1.98357L19.7295 2.62916L20.3437 3.04975L19.6078 3.16191L19.6618 3.90461L19.1147 3.3999ZM16.3792 7.50324L15.8327 8.00863L15.8868 7.26593L15.1502 7.15377L15.765 6.73249L15.3944 6.0869L16.1056 6.30506L16.3792 5.61228L16.6534 6.30506L17.3653 6.0869L16.994 6.73249L17.6081 7.15377L16.8722 7.26593L16.9263 8.00863L16.3792 7.50324ZM22.5342 6.13546L21.9877 6.64085L22.0418 5.89815L21.3052 5.78599L21.92 5.36471L21.5494 4.71912L22.2606 4.93728L22.5342 4.2445L22.8084 4.93728L23.5203 4.71912L23.149 5.36471L23.7631 5.78599L23.0273 5.89815L23.0813 6.64085L22.5342 6.13546ZM19.1147 15.7099L18.5683 16.2153L18.6223 15.4726L17.8858 15.3604L18.5006 14.9392L18.1299 14.2936L18.8412 14.5117L19.1147 13.8189L19.389 14.5117L20.1009 14.2936L19.7295 14.9392L20.3437 15.3604L19.6078 15.4726L19.6618 16.2153L19.1147 15.7099ZM21.2006 7.80278L21.4016 8.21038L21.851 8.27535L21.5261 8.59199L21.6027 9.03993L21.2006 8.82861L20.7985 9.03993L20.8751 8.59199L20.5502 8.27535L20.9995 8.21038L21.2006 7.80278Z"
      fill="white"
    />
    <path
      d="M12.9939 9.17055V0.279999H2.73556C2.51671 0.279999 2.32249 0.310774 2.32249 0.310774L2.31975 1.51031L0.452736 1.50758C0.452736 1.50758 0.424013 1.54793 0.365883 1.64778C0.125641 2.06354 -0.000572035 2.53537 1.94903e-06 3.01555V9.17055H12.9939Z"
      fill="#00247D"
    />
    <path
      d="M12.9939 0.279999H11.3997L8.20667 2.51563V0.279999H4.78722V2.03691L2.32249 0.310774C1.91137 0.372186 1.52002 0.527836 1.17902 0.76556L4.39467 3.01555H3.20744L0.661321 1.23129C0.586235 1.31905 0.516576 1.41132 0.452734 1.50758L2.60767 3.01555H0V6.435H2.65691L0 8.32664V9.17055H2.27872L4.78722 7.41433V9.17055H8.20667V6.93492L11.3991 9.17055H12.9939V7.78294L11.0687 6.435H12.9939V3.01555H11.0694L12.9939 1.66761V0.279999Z"
      fill="#EEEEEE"
    />
    <path
      d="M7.52278 0.279999H5.47111V3.69944H0V5.75111H5.47111V9.17055H7.52278V5.75111H12.9939V3.69944H7.52278V0.279999Z"
      fill="#CF1B2B"
    />
    <path
      d="M12.9939 0.279999H11.9948L8.20671 2.9328V3.01555H9.2811L12.9939 0.415409V0.279999ZM1.17906 0.76556C0.987599 0.898416 0.813658 1.05489 0.66136 1.23129L3.20748 3.01555H4.39403L1.17906 0.76556ZM4.40223 6.435L0.502014 9.17055H1.68309L4.78726 6.99715V6.435H4.40223ZM12.9939 9.03514V8.2008L10.4724 6.435H9.28041L12.9939 9.03514Z"
      fill="#CF1B2B"
    />
  </svg>
);

export const Listing = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_523_653)">
      <path
        d="M2.72515 5.80046L10.0005 10.009L17.2758 5.80046M10.0005 18.4011V10.0007M17.5008 13.3341V6.66717C17.5005 6.37488 17.4234 6.08781 17.2771 5.83476C17.1308 5.58171 16.9206 5.37157 16.6675 5.22543L10.8338 1.89194C10.5805 1.74565 10.293 1.66864 10.0005 1.66864C9.7079 1.66864 9.42048 1.74565 9.1671 1.89194L3.33349 5.22543C3.08037 5.37157 2.87012 5.58171 2.72385 5.83476C2.57758 6.08781 2.50042 6.37488 2.50012 6.66717V13.3341C2.50042 13.6264 2.57758 13.9135 2.72385 14.1665C2.87012 14.4196 3.08037 14.6297 3.33349 14.7759L9.1671 18.1094C9.42048 18.2557 9.7079 18.3327 10.0005 18.3327C10.293 18.3327 10.5805 18.2557 10.8338 18.1094L16.6675 14.7759C16.9206 14.6297 17.1308 14.4196 17.2771 14.1665C17.4234 13.9135 17.5005 13.6264 17.5008 13.3341Z"
        stroke="currentColor"
        strokeWidth="1.66674"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_523_653">
        <rect
          width="20.0009"
          height="20.0009"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DollarIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_523_688)">
      <path
        d="M10.0001 1.66833V18.3352"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8335 4.16846H7.08342C5.47257 4.16846 4.16672 5.47431 4.16672 7.08516V7.08516C4.16672 8.69601 5.47257 10.0019 7.08342 10.0019H12.9168C14.5277 10.0019 15.8335 11.3077 15.8335 12.9186V12.9186C15.8335 14.5294 14.5277 15.8353 12.9168 15.8353H4.16672"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_523_688">
        <rect
          width="20.0002"
          height="20.0002"
          fill="white"
          transform="translate(0 0.00170898)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UserAccount = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6675 17.5028V15.836C16.6675 14.9519 16.3162 14.1041 15.6911 13.4789C15.0659 12.8537 14.2181 12.5025 13.334 12.5025H6.66699C5.78289 12.5025 4.935 12.8537 4.30985 13.4789C3.6847 14.1041 3.3335 14.9519 3.3335 15.836V17.5028M13.334 5.83556C13.334 7.6766 11.8415 9.16905 10.0005 9.16905C8.15944 9.16905 6.66699 7.6766 6.66699 5.83556C6.66699 3.99453 8.15944 2.50208 10.0005 2.50208C11.8415 2.50208 13.334 3.99453 13.334 5.83556Z"
      stroke="currentColor"
      strokeWidth="1.66674"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProductIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_3196_69795)">
      <path
        d="M11.6668 1.6676H5.00016C4.55814 1.6676 4.13421 1.8432 3.82165 2.15576C3.50909 2.46832 3.3335 2.89224 3.3335 3.33427V16.6676C3.3335 17.1096 3.50909 17.5336 3.82165 17.8461C4.13421 18.1587 4.55814 18.3343 5.00016 18.3343H15.0002C15.4422 18.3343 15.8661 18.1587 16.1787 17.8461C16.4912 17.5336 16.6668 17.1096 16.6668 16.6676V6.6676L11.6668 1.6676Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6665 1.6676V6.6676H16.6665"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3332 10.8342H6.6665"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3332 14.1676H6.6665"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33317 7.50092H7.49984H6.6665"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3196_69795">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.000915527)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const OrderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_3196_69804)">
      <path
        d="M5 1.6676L2.5 5.00094V16.6676C2.5 17.1096 2.67559 17.5336 2.98816 17.8461C3.30072 18.1587 3.72464 18.3343 4.16667 18.3343H15.8333C16.2754 18.3343 16.6993 18.1587 17.0118 17.8461C17.3244 17.5336 17.5 17.1096 17.5 16.6676V5.00094L15 1.6676H5Z"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 5.00092H17.5"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3332 8.33423C13.3332 9.21828 12.982 10.0661 12.3569 10.6913C11.7317 11.3164 10.8839 11.6676 9.99984 11.6676C9.11578 11.6676 8.26794 11.3164 7.64281 10.6913C7.01769 10.0661 6.6665 9.21828 6.6665 8.33423"
        stroke="currentColor"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3196_69804">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.000915527)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const PaymentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <g clipPath="url(#clip0_3489_65564)">
      <path
        d="M15 1.66772V10.0012"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5001 3.33423H13.75C13.0597 3.33423 12.5 3.89388 12.5 4.58424V4.58424C12.5 5.27461 13.0597 5.83426 13.75 5.83426H16.25C16.9404 5.83426 17.5001 6.39391 17.5001 7.08427V7.08427C17.5001 7.77464 16.9404 8.33429 16.25 8.33429H12.5"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
      />
      <path
        d="M1.6665 16.6679V12.5012C1.6665 11.5807 2.41271 10.8345 3.33319 10.8345H4.16653C5.08702 10.8345 5.83322 11.5807 5.83322 12.5012V16.6679C5.83322 17.5884 5.08702 18.3346 4.16653 18.3346H3.33319C2.41271 18.3346 1.6665 17.5884 1.6665 16.6679Z"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
      />
      <path
        d="M5.8335 12.5012L8.65539 11.0902C8.98689 10.9245 9.36418 10.8739 9.72762 10.9466L11.9938 11.3999C12.7728 11.5557 13.3336 12.2397 13.3336 13.0342V14.1678M13.3336 14.1678H10.8336M13.3336 14.1678L16.542 12.2428C17.0589 11.9326 17.7305 12.1282 18.0001 12.6674V12.6674C18.1993 13.0658 18.1212 13.547 17.8062 13.8619L15.3571 16.311C15.1244 16.5437 14.8281 16.7023 14.5054 16.7668L11.2011 17.4277C10.9591 17.4761 10.7094 17.4702 10.47 17.4103L7.69924 16.7176C7.56703 16.6846 7.43128 16.6679 7.295 16.6679H5.8335"
        stroke="currentColor"
        strokeWidth="1.66669"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3489_65564">
        <rect
          width="20.0002"
          height="20.0002"
          fill="white"
          transform="translate(0 0.000976562)"
        />
      </clipPath>
    </defs>
  </svg>
);
